// ===== PRINT AREAS =====
const printAreas = {
  
  'womens-mineral-wash-cotton-crop-t-shirt': {
  dtg: {
    front: [
      { x: 135, y: 190, w: 210, h: 125, label: 'Front', maxW: 15, maxH: 9 }
    ],
    back: [
      { x: 135, y: 190, w: 210, h: 125, label: 'Back', maxW: 15, maxH: 9 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 190, w: 210, h: 125, label: 'Front', maxW: 15, maxH: 9 }
    ],
    back: [
      { x: 135, y: 190, w: 210, h: 125, maxW: 15, maxH: 9, label: 'Back' }
    ]
  }
},

  'womens-slim-fit-performance-t-shirt': {
  dtg: {
    front: [
      { x: 135, y: 195, w: 165, h: 240, label: 'Front', maxW: 10, maxH: 17 }
    ],
    back: [
      { x: 135, y: 195, w: 165, h: 240, label: 'Back', maxW: 10, maxH: 17 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 195, w: 165, h: 240, label: 'Front', maxW: 10, maxH: 17 }
    ],
    back: [
      { x: 135, y: 195, w: 165, h: 240, label: 'Back', maxW: 10, maxH: 17 }
    ]
  }
},

'contrast-piped-button-up-jersey': {
  dtg: {
    front: [
      { x: 75, y: 220, w: 82, h: 245, label: 'Left Front', maxW: 7, maxH: 19 },
      { x: 195, y: 220, w: 82, h: 245, label: 'Right Front', maxW: 7, maxH: 19 }
    ],
    back: [
      { x: 135, y: 195, w: 205, h: 245, label: 'Back', maxW: 15, maxH: 19 }
    ]
  },

  dtf: {
    front: [
         { x: 75, y: 220, w: 82, h: 245, label: 'Left Front', maxW: 7, maxH: 19 },
      { x: 195, y: 220, w: 82, h: 245, label: 'Right Front', maxW: 7, maxH: 19 }
    ],
    back: [
      { x: 135, y: 195, w: 205, h: 245, label: 'Back', maxW: 15, maxH: 19 }
    ]
  }
},
'drop-shoulder-short-sleeve-polo': {
  dtg: {
    front: [
      { x: 135, y: 205, w: 175, h: 210, label: 'Front', maxW: 10, maxH: 12 }
    ],
    back: [
      { x: 135, y: 205, w: 175, h: 210, label: 'Back', maxW: 10, maxH: 12 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 205, w: 175, h: 210, label: 'Front', maxW: 10, maxH: 12 }
    ],
    back: [
      { x: 135, y: 205, w: 175, h: 210, label: 'Back', maxW: 10, maxH: 12 }
    ]
  }
},
'quarter-zip-raglan-training-t-shirt': {

  dtg: {
    front: [
      {
        x: 140,
        y: 220,
        w: 132,
        h: 190,
        label: 'Front',
        maxW: 10,
        maxH: 15,
        points: [
          { x: 75,  y: 125 },
          { x: 206, y: 125 },
          { x: 206, y: 198 },
          { x: 186, y: 314 },
          { x: 95,  y: 314 },
          { x: 75,  y: 198 }
        ]
      }
    ],

    back: [
      {
        x: 137,
        y: 205,
        w: 196,
        h: 250,
        label: 'Back',
        maxW: 10,
        maxH: 19,
        points: [
          { x: 66,  y: 80 },
          { x: 200, y: 80 },
          { x: 235, y: 135 },
          { x: 235, y: 330 },
          { x: 39,  y: 330 },
          { x: 39,  y: 135 }
        ]
      }
    ]
  },

  dtf: {
     front: [
      {
        x: 140,
        y: 220,
        w: 132,
        h: 190,
        label: 'Front',
        maxW: 10,
        maxH: 15,
        points: [
          { x: 75,  y: 125 },
          { x: 206, y: 125 },
          { x: 206, y: 198 },
          { x: 186, y: 314 },
          { x: 95,  y: 314 },
          { x: 75,  y: 198 }
        ]
      }
    ],

    back: [
      {
        x: 137,
        y: 205,
        w: 196,
        h: 250,
        label: 'Back',
        maxW: 10,
        maxH: 19,
        points: [
          { x: 66,  y: 80 },
          { x: 200, y: 80 },
          { x: 235, y: 135 },
          { x: 235, y: 330 },
          { x: 39,  y: 330 },
          { x: 39,  y: 135 }
        ]
      }
    ]
  }

},
  't-shirt': {
    dtg: { front: [
      { x: 135, y: 190, w: 220, h: 240, label: 'Chest', maxW: 14, maxH: 18 }
    ] ,
    back: [
      { x: 135, y: 190, w: 220, h: 240, label: 'Back', maxW: 14, maxH: 19 }
    ]
    },

    dtf: { front: [
       { x: 135, y: 190, w: 220, h: 240, label: 'Chest', maxW: 14, maxH: 18 }
    ] ,
    back: [
      { x: 135, y: 190, w: 220, h: 240, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    embroidery: {
      front: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 200, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ] ,
    back: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 200, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
    },

    sleeve: { leftSleeve: [
      { x: 145, y: 270, w: 220, h: 200, label: 'Left Sleeve', maxW: 4.7, maxH: 4.7 }
    ], rightSleeve: [
      { x: 125, y: 270, w: 220, h: 200, label: 'Right Sleeve', maxW: 4.7, maxH: 4.7 }
    ]
    }
   },
   'classic-unisex-cotton-hoodie': {
  dtg: {
    front: [
      { x: 130, y: 200, w: 180, h: 130, label: 'Chest', maxW: 16, maxH: 19 }
    ],
    back: [
      { x: 135, y: 230, w: 185, h: 220, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  dtf: {
    front: [
      { x: 130, y: 160, w: 180, h: 130, label: 'Chest', maxW: 16, maxH: 19 }
    ],
    back: [
      { x: 135, y: 200, w: 185, h: 220, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  embroidery: {
    front: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },
      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ],
    back: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },
      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
  },

sleeve: { leftSleeve: [
  { x: 135, y: 250, w: 150, h: 160, label: 'Left Sleeve', maxW: 4, maxH: 4 }
], rightSleeve: [
  { x: 135, y: 250, w: 150, h: 160, label: 'Right Sleeve', maxW: 4, maxH: 4 }
]
}
},
'contrast-stitched-boxy-fleece-zip-hoodie': {
  dtg: {
    front: [
      { x: 88, y: 200, w: 80, h: 72, label: '', maxW: 7, maxH: 6 },
      { x: 180, y: 200, w: 80, h: 72, label: '', maxW: 7, maxH: 6 }
    ],
    back: [
      { x: 135, y: 215, w: 170, h: 135, label: 'Back', maxW: 16, maxH: 14 }
    ]
  },

  dtf: {
    front: [
       { x: 88, y: 200, w: 80, h: 72, label: '', maxW: 7, maxH: 6 },
      { x: 180, y: 200, w: 80, h: 72, label: '', maxW: 7, maxH: 6 }
    ],
    back: [
      { x: 135, y: 215, w: 170, h: 135, label: 'Back', maxW: 16, maxH: 14 }
    ]
  },

  embroidery: {
    front: [
      { x: 88, y: 170, w: 65, h: 65, label: '', maxW: 3, maxH: 3 },
      { x: 200, y: 170, w: 65, h: 65, label: '', maxW: 3, maxH: 3 }
    ],
    back: [
      { x: 135, y: 170, w: 160, h: 160, label: 'Back', maxW: 12, maxH: 12 }
    ]
  },

  sleeve: {
    leftSleeve: [
      { x: 180, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ],
    rightSleeve: [
      { x: 120, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
  }
},

'sunfade-zipper-boxy-hoodie': {
  dtg: {
    front: [
      { x: 85, y: 185, w: 85, h: 120, label: '', maxW: 8, maxH: 10 },
      { x: 185, y: 185, w: 85, h: 120, label: '', maxW: 8, maxH: 10 }
    ],
    back: [
      { x: 135, y: 230, w: 185, h: 200, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  dtf: {
    front: [
      { x: 85, y: 185, w: 85, h: 120, label: '', maxW: 8, maxH: 10 },
      { x: 185, y: 185, w: 85, h: 120, label: '', maxW: 8, maxH: 10 }
    ],
    back: [
      { x: 135, y: 230, w: 185, h: 200, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  embroidery: {
    front: [
      { x: 95, y: 170, w: 65, h: 65, label: 'Left Chest', maxW: 3, maxH: 3 },
      { x: 205, y: 170, w: 65, h: 65, label: 'Right Chest', maxW: 3, maxH: 3 }
    ],
    back: [
      { x: 135, y: 170, w: 160, h: 160, label: 'Back', maxW: 12, maxH: 12 }
    ]
  },

  sleeve: {
    leftSleeve: [
      { x: 180, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ],
    rightSleeve: [
      { x: 120, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
  }
},
'sunfade-frayed-fleece-hoodie': {
  dtg: {
    front: [
      { x: 135, y: 185, w: 145, h: 135, label: 'Chest', maxW: 12, maxH: 12 }
    ],
    back: [
      { x: 135, y: 210, w: 145, h: 135, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 185, w: 145, h: 135, label: 'Chest', maxW: 12, maxH: 12 }
    ],
    back: [
      { x: 135, y: 210, w: 145, h: 135, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  embroidery: {
    front: [
      { x: 135, y: 165, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 185, w: 145, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 }
    ],
    back: [
      { x: 135, y: 170, w: 160, h: 160, label: 'Back', maxW: 12, maxH: 12 }
    ]
  },

  sleeve: {
    leftSleeve: [
      { x: 180, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ],
    rightSleeve: [
      { x: 120, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
  }
},

'cropped-half-zip-hoodie': {

  dtg: {
    front: [
      { x: 98, y: 110, w: 60, h: 65, label: 'Left Chest', maxW: 2.5, maxH: 4 },
      { x: 170, y: 110, w: 60, h: 65, label: 'Right Chest', maxW: 2.5, maxH: 4 }
    ],
    back: [
      { x: 130, y: 150, w: 160, h: 100, label: 'Back', maxW: 11, maxH: 8 }
    ]
  },

  dtf: {
    front: [
      { x: 98, y: 110, w: 60, h: 65, label: 'Left Chest', maxW: 2.5, maxH: 4 },
      { x: 170, y: 110, w: 60, h: 65, label: 'Right Chest', maxW: 2.5, maxH: 4 }
    ],
    back: [
      { x: 130, y: 150, w: 160, h: 100, label: 'Back', maxW: 11, maxH: 8 }
    ]
  },

  embroidery: {
    front: [
      { x: 98, y: 110, w: 60, h: 95, label: 'Left Chest', maxW: 2.5, maxH: 4 },
      { x: 242, y: 110, w: 60, h: 95, label: 'Right Chest', maxW: 2.5, maxH: 4 }
    ],
    back: [
      { x: 70, y: 90, w: 260, h: 190, label: 'Back', maxW: 11, maxH: 8 }
    ]
  }

},

'essential-cropped-hoodie': {
  dtg: {
    front: [
      { x: 135, y: 195, w: 190, h: 115, label: '', maxW: 15, maxH: 9 }
    ],
    back: [
      { x: 135, y: 195, w: 190, h: 115, label: '', maxW: 15, maxH: 9 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 195, w: 190, h: 115, label: '', maxW: 15, maxH: 9 }
    ],
    back: [
      { x: 135, y: 195, w: 190, h: 115, label: '', maxW: 15, maxH: 9 }
    ]
  },

  embroidery: {
    front: [
      { x: 135, y: 170, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 185, w: 145, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 }
    ],
    back: [
      { x: 135, y: 170, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 185, w: 145, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 }
    ]
  },

  sleeve: {
    leftSleeve: [
      { x: 180, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ],
    rightSleeve: [
      { x: 120, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
  }
},

'fleeced-full-zip-boxy-hoodie': {
 
    dtg: {
    front: [
      { x: 70, y: 170, w: 95, h: 82, label: '', maxW: 9, maxH: 7 },
      { x: 200, y: 170, w: 95, h: 82, label: '', maxW: 9, maxH: 7 }
    ],
    back: [
      { x: 135, y: 220, w: 180, h: 210, label: '', maxW: 15, maxH: 9 }
    ]
  },
  
  dtf: {
    front: [
      { x: 70, y: 170, w: 95, h: 82, label: '', maxW: 9, maxH: 7 },
      { x: 200, y: 170, w: 95, h: 82, label: '', maxW: 9, maxH: 7 }
    ],
    back: [
      { x: 135, y: 220, w: 180, h: 210, label: '', maxW: 15, maxH: 9 }
    ]
  },

  sleeve: {
    leftSleeve: [
      { x: 180, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ],
    rightSleeve: [
      { x: 120, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
  }
},

'essential-heavyweight-pocket-hoodie': {
  dtg: {
    front: [
      { x: 86, y: 195, w: 82, h: 130, label: '', maxW: 7, maxH: 11 },
      { x: 185, y: 195, w: 82, h: 130, label: '', maxW: 7, maxH: 11 }
    ],
    back: [
      { x: 135, y: 210, w: 185, h: 200, label: 'Back', maxW: 15, maxH: 18 }
    ]
  },

  dtf: {
        front: [
      { x: 86, y: 195, w: 82, h: 130, label: '', maxW: 7, maxH: 11 },
      { x: 185, y: 195, w: 82, h: 130, label: '', maxW: 7, maxH: 11 }
    ],
    back: [
       { x: 135, y: 210, w: 185, h: 200, label: 'Back', maxW: 15, maxH: 18 }
    ]
  },

  embroidery: {
    front: [
      { x: 92, y: 180, w: 65, h: 65, label: '', maxW: 3, maxH: 3 },
      { x: 198, y: 180, w: 65, h: 65, label: '', maxW: 3, maxH: 3 }
    ],
    back: [
      { x: 135, y: 170, w: 160, h: 160, label: 'Back', maxW: 12, maxH: 12 }
    ]
  },

  sleeve: {
    leftSleeve: [
      { x: 180, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ],
    rightSleeve: [
      { x: 120, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
  }
},

'heavyweight-460gsm-hidden-pocket-fleece-hoodie': {
  dtg: {
    front: [
      { x: 135, y: 215, w: 200, h: 350, label: '', maxW: 14, maxH: 19 }
    ],
    back: [
      { x: 135, y: 225, w: 200, h: 350, label: '', maxW: 14, maxH: 19 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 215, w: 200, h: 350, label: '', maxW: 14, maxH: 19 }
    ],
    back: [
      { x: 135, y: 225, w: 200, h: 350, label: '', maxW: 14, maxH: 19 }
    ]
  }
},

'fleeced-boxy-hoodie': {
  dtg: {
    front: [
      { x: 135, y: 210, w: 170, h: 210, label: '', maxW: 14, maxH: 19 }
    ],
    back: [
      { x: 135, y: 200, w: 170, h: 210, label: '', maxW: 14, maxH: 19 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 210, w: 170, h: 210, label: '', maxW: 14, maxH: 19 }
    ],
    back: [
      { x: 135, y: 200, w: 170, h: 210, label: '', maxW: 14, maxH: 19 }
    ]
  }
},

'unisex-leopard-print-waffle-full-zip-hoodie': {
  dtg: {
    front: [
      { x: 75, y: 185, w: 110, h: 110, label: 'Front Left', maxW: 9.5, maxH: 9.5 },
      { x: 197, y: 185, w: 110, h: 110, label: 'Front Right', maxW: 9.5, maxH: 9.5 }
    ],
    back: [
      { x: 135, y: 235, w: 190, h: 200, label: 'Back', maxW: 15, maxH: 17 }
    ]
  },

  dtf: {
    front: [
         { x: 75, y: 185, w: 110, h: 110, label: 'Front Left', maxW: 9.5, maxH: 9.5 },
      { x: 197, y: 185, w: 110, h: 110, label: 'Front Right', maxW: 9.5, maxH: 9.5 }
    ],
    back: [
      { x: 135, y: 235, w: 190, h: 200, label: 'Back', maxW: 15, maxH: 17 }
    ]
  }
},

'dirty-washed-zip-up-fleece-hoodie': {
  dtg: {
    front: [
      { x: 82, y: 125, w: 90, h: 115, label: 'Front Left', maxW: 8, maxH: 10 },
      { x: 188, y: 125, w: 90, h: 115, label: 'Front Right', maxW: 8, maxH: 10 }
    ],
    back: [
      { x: 135, y: 185, w: 200, h: 220, label: 'Back', maxW: 15, maxH: 17 }
    ]
  },

  dtf: {
      front: [
      { x: 82, y: 125, w: 90, h: 115, label: 'Front Left', maxW: 8, maxH: 10 },
      { x: 188, y: 125, w: 90, h: 115, label: 'Front Right', maxW: 8, maxH: 10 }
    ],
    back: [
      { x: 135, y: 185, w: 200, h: 220, label: 'Back', maxW: 15, maxH: 17 }
    ]
  }
},

'heavyweight-raglan-sleeve-zip-hoodie': {
  dtg: {
    front: [
      {
        x: 92,
        y: 168,
        w: 75,
        h: 125,
        label: 'Front Left',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 55, y: 225 },
          { x: 55, y: 165 },
          { x: 90, y: 115 },
          { x: 130, y: 115 },
          { x: 130, y: 240 },
          { x: 55, y: 240 }
        ]
      },
      {
        x: 178,
        y: 168,
        w: 75,
        h: 125,
        label: 'Front Right',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 140, y: 115 },
          { x: 180, y: 115 },
          { x: 215, y: 165 },
          { x: 215, y: 240 },
          { x: 140, y: 240 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 235,
        w: 146,
        h: 230,
        label: 'Back',
        maxW: 15,
        maxH: 17,
        points: [
          { x: 62, y: 350 },
          { x: 62, y: 185 },
          { x: 105, y: 120 },
          { x: 165, y: 120 },
          { x: 208, y: 185 },
          { x: 208, y: 350 }
        ]
      }
    ]
  },

  dtf: {
      front: [
      {
        x: 92,
        y: 168,
        w: 75,
        h: 125,
        label: 'Front Left',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 55, y: 225 },
          { x: 55, y: 165 },
          { x: 90, y: 115 },
          { x: 130, y: 115 },
          { x: 130, y: 240 },
          { x: 55, y: 240 }
        ]
      },
      {
        x: 178,
        y: 168,
        w: 75,
        h: 125,
        label: 'Front Right',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 140, y: 115 },
          { x: 180, y: 115 },
          { x: 215, y: 165 },
          { x: 215, y: 240 },
          { x: 140, y: 240 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 235,
        w: 146,
        h: 230,
        label: 'Back',
        maxW: 15,
        maxH: 17,
        points: [
          { x: 62, y: 350 },
          { x: 62, y: 185 },
          { x: 105, y: 120 },
          { x: 165, y: 120 },
          { x: 208, y: 185 },
          { x: 208, y: 350 }
        ]
      }
    ]
  }
},
  'hoodie': {
    dtg: { front: [
      { x: 135, y: 195, w: 185, h: 130, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 230, w: 185, h: 220, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    dtf: { front: [
    { x: 135, y: 195, w: 185, h: 130, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 230, w: 185, h: 220, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    embroidery: {
      front: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ] ,
    back: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
    },

    sleeve: { leftSleeve: [
      { x: 180, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ], rightSleeve: [
      { x: 120, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
    }
   },
   'sun-fade-frayed-raw-edge-fleece-zip-hoodie': {
  dtg: {
    front: [
      { x: 80, y: 170, w: 80, h: 100, label: 'Front Left', maxW: 8, maxH: 12 },
      { x: 180, y: 170, w: 80, h: 100, label: 'Front Right', maxW: 8, maxH: 12 }
    ],
    back: [
      { x: 135, y: 205, w: 190, h: 190, label: 'Back', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
     front: [
      { x: 80, y: 170, w: 80, h: 100, label: 'Front Left', maxW: 8, maxH: 12 },
      { x: 180, y: 170, w: 80, h: 100, label: 'Front Right', maxW: 8, maxH: 12 }
    ],
    back: [
      { x: 135, y: 205, w: 190, h: 190, label: 'Back', maxW: 14, maxH: 16 }
    ]
  }
},
  
'baseball-jacket': {
  dtg: {
    front: [
      {
        label: 'Front Left',
        maxW: 5,
        maxH: 7,
        points: [
          { x: 58, y: 138 },
          { x: 78, y: 95 },
          { x: 128, y: 95 },
          { x: 128, y: 180 },
          { x: 58, y: 180 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 5,
        maxH: 7,
        points: [
        { x: 142, y: 95 },
{ x: 192, y: 95 },
{ x: 212, y: 138 },
{ x: 212, y: 180 },
{ x: 142, y: 180 }
        ]
      }
    ],
    back: [
      {
        label: 'Back',
        maxW: 13,
        maxH: 17,
        points: [
          { x: 58, y: 220 },
          { x: 58, y: 125 },
          { x: 88, y: 85 },
          { x: 182, y: 85 },
          { x: 212, y: 125 },
          { x: 212, y: 220 }
        ]
      }
    ]
  },

  dtf: {
    front: [
      {
        label: 'Front Left',
        maxW: 5,
        maxH: 7,
        points: [
          { x: 58, y: 138 },
          { x: 78, y: 95 },
          { x: 128, y: 95 },
          { x: 128, y: 180 },
          { x: 58, y: 180 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 5,
        maxH: 7,
        points: [
        { x: 142, y: 95 },
{ x: 192, y: 95 },
{ x: 212, y: 138 },
{ x: 212, y: 180 },
{ x: 142, y: 180 }
        ]
      }
    ],
    back: [
      {
        label: 'Back',
        maxW: 13,
        maxH: 17,
        points: [
          { x: 58, y: 220 },
          { x: 58, y: 125 },
          { x: 88, y: 85 },
          { x: 182, y: 85 },
          { x: 212, y: 125 },
          { x: 212, y: 220 }
        ]
      }
    ]
  }
},

'womens-full-zip-sports-jacket': {

  dtg: {

    front: [

      {
        x: 95,
        y: 130,
        w: 70,
        h: 100,
        label: 'Left Chest',
        maxW: 2.5,
        maxH: 5
      },

      {
        x: 175,
        y: 130,
        w: 70,
        h: 100,
        label: 'Right Chest',
        maxW: 2.5,
        maxH: 5
      }

    ],

    back: [

      {
        x: 135,
        y: 145,
        w: 90,
        h: 200,
        label: 'Back',
        maxW: 5,
        maxH: 13
      }

    ]

  },

  dtf: {

     front: [

      {
        x: 95,
        y: 130,
        w: 70,
        h: 100,
        label: 'Left Chest',
        maxW: 2.5,
        maxH: 5
      },

      {
        x: 175,
        y: 130,
        w: 70,
        h: 100,
        label: 'Right Chest',
        maxW: 2.5,
        maxH: 5
      }

    ],

    back: [

      {
        x: 135,
        y: 145,
        w: 90,
        h: 200,
        label: 'Back',
        maxW: 5,
        maxH: 13
      }

    ]

  },

  embroidery: {

    front: [

      {
        x: 145,
        y: 170,
        w: 70,
        h: 140,
        label: 'Left Chest',
        maxW: 2.5,
        maxH: 5
      },

      {
        x: 275,
        y: 170,
        w: 70,
        h: 140,
        label: 'Right Chest',
        maxW: 2.5,
        maxH: 5
      }

    ],

    back: [

      {
        x: 170,
        y: 145,
        w: 160,
        h: 340,
        label: 'Back',
        maxW: 5,
        maxH: 13
      }

    ]

  }

},

'soft-hooded-sports-jacket': {
  dtg: {
    front: [
      { x: 90, y: 160, w: 85, h: 230, label: 'Front Left', maxW: 5, maxH: 15 },
      { x: 180, y: 160, w: 85, h: 230, label: 'Front Right', maxW: 5, maxH: 15 }
    ],
    back: [
      { x: 135, y: 205, w: 170, h: 225, label: 'Back', maxW: 9, maxH: 12 }
    ]
  },

  dtf: {
    front: [
         { x: 90, y: 160, w: 85, h: 230, label: 'Front Left', maxW: 5, maxH: 15 },
      { x: 180, y: 160, w: 85, h: 230, label: 'Front Right', maxW: 5, maxH: 15 }
    ],
    back: [
      { x: 135, y: 205, w: 170, h: 225, label: 'Back', maxW: 9, maxH: 12 }
    ]
  }
},

'unisex-plaid-full-zip-track-jacket': {
  dtg: {
    front: [
      {
        label: 'Front Left',
        maxW: 7,
        maxH: 7,
        points: [
           { x: 48, y: 180 },
          { x: 70, y: 80 },
          { x: 130, y: 80 },
          { x: 130, y: 180 },
          { x: 48, y: 180 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 7,
        maxH: 7,
        points: [
     { x: 222, y: 180 },
{ x: 200, y: 80 },
{ x: 140, y: 80 },
{ x: 140, y: 180 },
{ x: 222, y: 180 }
        ]
      }
    ],
    back: [
      {
        label: 'Back',
        maxW: 14,
        maxH: 14,
points: [
  { x: 42, y: 195 },
  { x: 42, y: 120 },
  { x: 78, y: 70 },
  { x: 192, y: 70 },
  { x: 228, y: 120 },
  { x: 228, y: 195 }
]
      }
    ]
  },

  dtf: {
 front: [
      {
        label: 'Front Left',
        maxW: 7,
        maxH: 7,
        points: [
           { x: 48, y: 180 },
          { x: 70, y: 80 },
          { x: 130, y: 80 },
          { x: 130, y: 180 },
          { x: 48, y: 180 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 7,
        maxH: 7,
        points: [
     { x: 222, y: 180 },
{ x: 200, y: 80 },
{ x: 140, y: 80 },
{ x: 140, y: 180 },
{ x: 222, y: 180 }
        ]
      }
    ],
    back: [
      {
        label: 'Back',
        maxW: 14,
        maxH: 14,
points: [
  { x: 42, y: 195 },
  { x: 42, y: 120 },
  { x: 78, y: 70 },
  { x: 192, y: 70 },
  { x: 228, y: 120 },
  { x: 228, y: 195 }
        ]
      }
    ]
  }
},

'unisex-vintage-wash-denim-jacket': {
  dtg: {
    front: [
      { x: 80, y: 80, w: 85, h: 45, label: '', maxW: 7, maxH: 4 },
      { x: 192, y: 80, w: 85, h: 45, label: '', maxW: 7, maxH: 4 }
    ],
    back: [
      { x: 135, y: 45, w: 225, h: 40, label: '', maxW: 14, maxH: 4 },
      { x: 135, y: 180, w: 120, h: 170, label: '', maxW: 10, maxH: 16 }
    ]
  },

  dtf: {
    front: [
      { x: 80, y: 80, w: 85, h: 45, label: '', maxW: 7, maxH: 4 },
      { x: 192, y: 80, w: 85, h: 45, label: '', maxW: 7, maxH: 4 }
    ],
    back: [
      { x: 135, y: 45, w: 225, h: 40, label: '', maxW: 14, maxH: 4 },
      { x: 135, y: 180, w: 120, h: 170, label: '', maxW: 10, maxH: 16 }
    ]
  }
},

'stand-collar-bomber-jacket': {
  dtg: {
    front: [
      { x: 80, y: 150, w: 90, h: 125, label: 'Front Left', maxW: 6, maxH: 9 },
      { x: 190, y: 150, w: 90, h: 125, label: 'Front Right', maxW: 6, maxH: 9 }
    ],
    back: [
      { x: 135, y: 150, w: 190, h: 160, label: 'Back', maxW: 14, maxH: 14 }
    ]
  },

  dtf: {
    front: [
      { x: 80, y: 150, w: 90, h: 125, label: 'Front Left', maxW: 6, maxH: 9 },
      { x: 190, y: 150, w: 90, h: 125, label: 'Front Right', maxW: 6, maxH: 9 }
    ],
    back: [
      { x: 135, y: 150, w: 190, h: 160, label: 'Back', maxW: 14, maxH: 14 }
    ]
  }
},

'unisex-vintage-wash-full-zip-denim-jacket': {
  dtg: {
    front: [
      { x: 70, y: 130, w: 105, h: 95, label: 'Front Left', maxW: 8, maxH: 7 },
      { x: 200, y: 130, w: 105, h: 95, label: 'Front Right', maxW: 8, maxH: 7 }
    ],
    back: [
      { x: 135, y: 165, w: 190, h: 180, label: 'Back', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
   front: [
      { x: 70, y: 130, w: 105, h: 95, label: 'Front Left', maxW: 8, maxH: 7 },
      { x: 200, y: 130, w: 105, h: 95, label: 'Front Right', maxW: 8, maxH: 7 }
    ],
    back: [
      { x: 135, y: 165, w: 190, h: 180, label: 'Back', maxW: 14, maxH: 16 }
    ]
  }
},

'reflection-striped-raglan-sleeve-jacket': {
  dtg: {
    front: [
      { x: 95, y: 220, w: 60, h: 180, label: 'Front Left', maxW: 8, maxH: 12 },
      { x: 175, y: 220, w: 60, h: 180, label: 'Front Right', maxW: 8, maxH: 12 }
    ],
    back: [
      { x: 135, y: 205, w: 155, h: 180, label: 'Back', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
     front: [
      { x: 95, y: 220, w: 60, h: 180, label: 'Front Left', maxW: 8, maxH: 12 },
      { x: 175, y: 220, w: 60, h: 180, label: 'Front Right', maxW: 8, maxH: 12 }
    ],
    back: [
      { x: 135, y: 205, w: 155, h: 180, label: 'Back', maxW: 14, maxH: 16 }
    ]
  }
},

'womens-button-front-jacket': {
  dtg: {
    front: [
      {
        label: 'Front Left',
        maxW: 6,
        maxH: 10,
        points: [
       { x: 60, y: 145 },
{ x: 85, y: 105 },
{ x: 120, y: 105 },
{ x: 120, y: 225 },
{ x: 60, y: 225 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 6,
        maxH: 10,
        points: [
         { x: 150, y: 105 },
{ x: 185, y: 105 },
{ x: 210, y: 145 },
{ x: 210, y: 225 },
{ x: 150, y: 225 }
        ]
      }
    ],
    back: [
      { x: 135, y: 115, w: 160, h: 25, label: 'Back Upper', maxW: 14, maxH: 3 },
      { x: 135, y: 175, w: 130, h: 70, label: 'Back Main', maxW: 12, maxH: 6 }
    ]
  },

  dtf: {
    front: [
      {
        label: 'Front Left',
        maxW: 6,
        maxH: 10,
        points: [
       { x: 60, y: 145 },
{ x: 85, y: 105 },
{ x: 120, y: 105 },
{ x: 120, y: 225 },
{ x: 60, y: 225 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 6,
        maxH: 10,
        points: [
         { x: 150, y: 105 },
{ x: 185, y: 105 },
{ x: 210, y: 145 },
{ x: 210, y: 225 },
{ x: 150, y: 225 }
        ]
      }
    ],
    back: [
      { x: 135, y: 115, w: 160, h: 25, label: 'Back Upper', maxW: 14, maxH: 3 },
      { x: 135, y: 175, w: 130, h: 70, label: 'Back Main', maxW: 12, maxH: 6 }
    ]
  }
},

'color-block-raglan-sleeve-zip-track-jacket': {
  dtg: {
    front: [
      {
        label: 'Front Left',
        maxW: 6,
        maxH: 8,
        points: [
          { x: 55, y: 163 },
          { x: 75, y: 115 },
          { x: 125, y: 115 },
          { x: 125, y: 210 },
          { x: 55, y: 210 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 6,
        maxH: 8,
        points: [
          { x: 147, y: 115 },
          { x: 197, y: 115 },
          { x: 217, y: 163 },
          { x: 217, y: 210 },
          { x: 147, y: 210 }
        ]
      }
    ],
    back: [
      {
        label: 'Back',
        maxW: 14,
        maxH: 14,
        points: [
          { x: 68, y: 235 },
          { x: 68, y: 145 },
          { x: 98, y: 105 },
          { x: 192, y: 105 },
          { x: 222, y: 145 },
          { x: 222, y: 235 }
        ]
      }
    ]
  },

  dtf: {
    front: [
      {
        label: 'Front Left',
        maxW: 6,
        maxH: 8,
        points: [
          { x: 55, y: 163 },
          { x: 75, y: 115 },
          { x: 125, y: 115 },
          { x: 125, y: 210 },
          { x: 55, y: 210 }
        ]
      },
      {
        label: 'Front Right',
        maxW: 6,
        maxH: 8,
        points: [
          { x: 147, y: 115 },
          { x: 197, y: 115 },
          { x: 217, y: 163 },
          { x: 217, y: 210 },
          { x: 147, y: 210 }
        ]
      }
    ],
    back: [
      {
        label: 'Back',
        maxW: 14,
        maxH: 14,
        points: [
          { x: 68, y: 235 },
          { x: 68, y: 145 },
          { x: 98, y: 105 },
          { x: 192, y: 105 },
          { x: 222, y: 145 },
          { x: 222, y: 235 }
        ]
      }
    ]
  }
},

'contrast-trim-stand-collar-jacket': {
  dtg: {
    front: [
      { x: 82, y: 150, w: 85, h: 120, label: 'Front Left', maxW: 7, maxH: 9 },
      { x: 188, y: 150, w: 85, h: 120, label: 'Front Right', maxW: 7, maxH: 9 }
    ],
    back: [
      { x: 135, y: 200, w: 185, h: 210, label: 'Back', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
    front: [
      { x: 82, y: 150, w: 85, h: 120, label: 'Front Left', maxW: 7, maxH: 9 },
      { x: 188, y: 150, w: 85, h: 120, label: 'Front Right', maxW: 7, maxH: 9 }
    ],
    back: [
      { x: 135, y: 200, w: 185, h: 210, label: 'Back', maxW: 14, maxH: 16 }
    ]
  }
},

'essential-heavyweight-sweat-cardigan': {
  dtg: {
    front: [
      { x: 85, y: 220, w: 80, h: 150, label: 'Front Left', maxW: 7, maxH: 11 },
      { x: 185, y: 220, w: 80, h: 150, label: 'Front Right', maxW: 7, maxH: 11 }
    ],
    back: [
      { x: 135, y: 200, w: 185, h: 240, label: 'Back', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
    front: [
      { x: 85, y: 220, w: 80, h: 150, label: 'Front Left', maxW: 7, maxH: 11 },
      { x: 185, y: 220, w: 80, h: 150, label: 'Front Right', maxW: 7, maxH: 11 }
    ],
    back: [
      { x: 135, y: 200, w: 185, h: 240, label: 'Back', maxW: 14, maxH: 16 }
    ]
  }
},

'denim-vintage-washed-heavyweight-jacket': {
  dtg: {
    front: [
      { x: 70, y: 100, w: 70, h: 45, label: 'Front Left Chest', maxW: 7, maxH: 4 },
      { x: 190, y: 100, w: 70, h: 45, label: 'Front Right Chest', maxW: 7, maxH: 4 },
      { x: 75, y: 230, w: 90, h: 160, label: 'Front Left Main', maxW: 8, maxH: 14 },
      { x: 188, y: 230, w: 90, h: 160, label: 'Front Right Main', maxW: 8, maxH: 14 }
    ],
    back: [
      { x: 135, y: 60, w: 220, h: 45, label: 'Back Upper', maxW: 14, maxH: 4 },
      { x: 135, y: 245, w: 205, h: 190, label: 'Back Main', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
    front: [
      { x: 82, y: 105, w: 80, h: 45, label: 'Front Left Chest', maxW: 7, maxH: 4 },
      { x: 188, y: 105, w: 80, h: 45, label: 'Front Right Chest', maxW: 7, maxH: 4 },
      { x: 82, y: 245, w: 90, h: 185, label: 'Front Left Main', maxW: 8, maxH: 14 },
      { x: 188, y: 245, w: 90, h: 185, label: 'Front Right Main', maxW: 8, maxH: 14 }
    ],
    back: [
      { x: 135, y: 90, w: 220, h: 45, label: 'Back Upper', maxW: 14, maxH: 4 },
      { x: 135, y: 245, w: 205, h: 190, label: 'Back Main', maxW: 14, maxH: 16 }
    ]
  }
},

'vintage-wash-zip-denim-jacket': {
  dtg: {
    front: [
      { x: 82, y: 95, w: 90, h: 40, label: 'Front Left Upper', maxW: 7, maxH: 3 },
      { x: 188, y: 95, w: 90, h: 40, label: 'Front Right Upper', maxW: 7, maxH: 3 },
      { x: 82, y: 175, w: 90, h: 75, label: 'Front Left Main', maxW: 7, maxH: 6 },
      { x: 188, y: 175, w: 90, h: 75, label: 'Front Right Main', maxW: 7, maxH: 6 }
    ],
    back: [
      { x: 135, y: 95, w: 210, h: 25, label: 'Back Upper', maxW: 14, maxH: 3 },
      { x: 135, y: 230, w: 200, h: 170, label: 'Back Main', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
      front: [
      { x: 82, y: 95, w: 90, h: 40, label: 'Front Left Upper', maxW: 7, maxH: 3 },
      { x: 188, y: 95, w: 90, h: 40, label: 'Front Right Upper', maxW: 7, maxH: 3 },
      { x: 82, y: 175, w: 90, h: 75, label: 'Front Left Main', maxW: 7, maxH: 6 },
      { x: 188, y: 175, w: 90, h: 75, label: 'Front Right Main', maxW: 7, maxH: 6 }
    ],
    back: [
      { x: 135, y: 95, w: 210, h: 25, label: 'Back Upper', maxW: 14, maxH: 3 },
      { x: 135, y: 230, w: 200, h: 170, label: 'Back Main', maxW: 14, maxH: 16 }
    ]
  }
},

'essential-heavyweight-stand-collar-jacket': {
  dtg: {
    front: [
      { x: 88, y: 210, w: 85, h: 220, label: 'Front Left', maxW: 7, maxH: 16 },
      { x: 182, y: 210, w: 85, h: 220, label: 'Front Right', maxW: 7, maxH: 16 }
    ],
    back: [
      { x: 135, y: 205, w: 190, h: 220, label: 'Back', maxW: 14, maxH: 16 }
    ]
  },

  dtf: {
    front: [
      { x: 88, y: 210, w: 85, h: 220, label: 'Front Left', maxW: 7, maxH: 16 },
      { x: 182, y: 210, w: 85, h: 220, label: 'Front Right', maxW: 7, maxH: 16 }
    ],
    back: [
      { x: 135, y: 205, w: 190, h: 220, label: 'Back', maxW: 14, maxH: 16 }
    ]
  }
},

'contrast-side-stripe-stand-collar-jacket': {
  dtg: {
    front: [
      { x: 86, y: 150, w: 85, h: 135, label: 'Front Left', maxW: 7, maxH: 11 },
      { x: 184, y: 150, w: 85, h: 135, label: 'Front Right', maxW: 7, maxH: 11 }
    ],
    back: [
      { x: 135, y: 90, w: 180, h: 45, label: 'Back Upper', maxW: 14, maxH: 4 },
      { x: 135, y: 200, w: 180, h: 145, label: 'Back Main', maxW: 14, maxH: 12 }
    ]
  },

  dtf: {
      front: [
      { x: 86, y: 150, w: 85, h: 135, label: 'Front Left', maxW: 7, maxH: 11 },
      { x: 184, y: 150, w: 85, h: 135, label: 'Front Right', maxW: 7, maxH: 11 }
    ],
    back: [
      { x: 135, y: 90, w: 180, h: 45, label: 'Back Upper', maxW: 14, maxH: 4 },
      { x: 135, y: 200, w: 180, h: 145, label: 'Back Main', maxW: 14, maxH: 12 }
    ]
  }
},

'contrast-side-stripe-fleece-cropped-track-jacket': {
  dtg: {
    front: [
      { x: 88, y: 140, w: 65, h: 65, label: 'Front Left', maxW: 6, maxH: 6 },
      { x: 182, y: 140, w: 65, h: 65, label: 'Front Right', maxW: 6, maxH: 6 }
    ],
    back: [
      { x: 135, y: 180, w: 150, h: 150, label: 'Back', maxW: 14, maxH: 14 }
    ]
  },

  dtf: {
 front: [
      { x: 88, y: 140, w: 65, h: 65, label: 'Front Left', maxW: 6, maxH: 6 },
      { x: 182, y: 140, w: 65, h: 65, label: 'Front Right', maxW: 6, maxH: 6 }
    ],
    back: [
      { x: 135, y: 180, w: 150, h: 150, label: 'Back', maxW: 14, maxH: 14 }
    ]
  }
},

'unisex-vintage-wash-full-zip-mesh-jacket': {
  dtg: {
    front: [
      {
        x: 106,
        y: 170,
        w: 48,
        h: 130,
        label: 'Front Left',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 82, y: 205 },
          { x: 82, y: 145 },
          { x: 112, y: 105 },
          { x: 130, y: 105 },
          { x: 130, y: 235 },
          { x: 82, y: 235 }
        ]
      },
      {
        x: 164,
        y: 170,
        w: 48,
        h: 130,
        label: 'Front Right',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 140, y: 105 },
          { x: 158, y: 105 },
          { x: 188, y: 145 },
          { x: 188, y: 235 },
          { x: 140, y: 235 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 185,
        w: 114,
        h: 125,
        label: 'Back',
        maxW: 14,
        maxH: 15,
        points: [
          { x: 78, y: 235 },
          { x: 78, y: 140 },
          { x: 98, y: 110 },
          { x: 172, y: 110 },
          { x: 192, y: 140 },
          { x: 192, y: 235 }
        ]
      }
    ]
  },

  dtf: {
    front: [
      {
        x: 106,
        y: 170,
        w: 48,
        h: 130,
        label: 'Front Left',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 82, y: 205 },
          { x: 82, y: 145 },
          { x: 112, y: 105 },
          { x: 130, y: 105 },
          { x: 130, y: 235 },
          { x: 82, y: 235 }
        ]
      },
      {
        x: 164,
        y: 170,
        w: 48,
        h: 130,
        label: 'Front Right',
        maxW: 6,
        maxH: 9,
        points: [
          { x: 140, y: 105 },
          { x: 158, y: 105 },
          { x: 188, y: 145 },
          { x: 188, y: 235 },
          { x: 140, y: 235 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 185,
        w: 114,
        h: 125,
        label: 'Back',
        maxW: 14,
        maxH: 15,
        points: [
          { x: 78, y: 235 },
          { x: 78, y: 140 },
          { x: 98, y: 110 },
          { x: 172, y: 110 },
          { x: 192, y: 140 },
          { x: 192, y: 235 }
        ]
      }
    ]
  }
},

'unisex-vintage-wash-mesh-full-zip-vest': {
  dtg: {
    front: [
      {
        x: 98,
        y: 175,
        w: 75,
        h: 155,
        label: 'Front Left',
        maxW: 7,
        maxH: 12,
        points: [
          { x: 55, y: 205 },
          { x: 55, y: 115 },
          { x: 93, y: 73 },
          { x: 130, y: 73 },
          { x: 130, y: 205 }
        ]
      },
      {
        x: 172,
        y: 175,
        w: 75,
        h: 155,
        label: 'Front Right',
        maxW: 7,
        maxH: 12,
        points: [
 { x: 140, y: 73 },
{ x: 177, y: 73 },
{ x: 215, y: 115 },
{ x: 215, y: 205 },
{ x: 140, y: 205 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 205,
        w: 175,
        h: 250,
        label: 'Back',
        maxW: 14,
        maxH: 18,
        points: [
          { x: 48, y: 320 },
          { x: 48, y: 105 },
          { x: 62, y: 62 },
          { x: 208, y: 62 },
          { x: 222, y: 105 },
          { x: 222, y: 320 }
        ]
      }
    ]
  },

  dtf: {
    front: [
      {
        x: 98,
        y: 175,
        w: 75,
        h: 155,
        label: 'Front Left',
        maxW: 7,
        maxH: 12,
        points: [
          { x: 55, y: 205 },
          { x: 55, y: 115 },
          { x: 93, y: 73 },
          { x: 130, y: 73 },
          { x: 130, y: 205 }
        ]
      },
      {
        x: 172,
        y: 175,
        w: 75,
        h: 155,
        label: 'Front Right',
        maxW: 7,
        maxH: 12,
        points: [
 { x: 140, y: 73 },
{ x: 177, y: 73 },
{ x: 215, y: 115 },
{ x: 215, y: 205 },
{ x: 140, y: 205 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 205,
        w: 175,
        h: 250,
        label: 'Back',
        maxW: 14,
        maxH: 18,
        points: [
          { x: 48, y: 320 },
          { x: 48, y: 105 },
          { x: 62, y: 62 },
          { x: 208, y: 62 },
          { x: 222, y: 105 },
          { x: 222, y: 320 }
        ]
      }
    ]
  }
},
'denim-vintage-washed-jacket': {
  dtg: {
    front: [
      {
        x: 92,
        y: 160,
        w: 72,
        h: 120,
        label: 'Front Left',
        maxW: 5,
        maxH: 9,
        points: [
          { x: 55, y: 190 },
          { x: 55, y: 115 },
          { x: 90, y: 75 },
          { x: 130, y: 75 },
          { x: 130, y: 190 }
        ]
      },
      {
        x: 178,
        y: 160,
        w: 72,
        h: 120,
        label: 'Front Right',
        maxW: 5,
        maxH: 9,
        points: [
          { x: 140, y: 75 },
          { x: 180, y: 75 },
          { x: 215, y: 115 },
          { x: 215, y: 190 },
          { x: 140, y: 190 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 230,
        w: 185,
        h: 220,
        label: 'Back',
        maxW: 12,
        maxH: 18,
        points: [
          { x: 72, y: 300 },
          { x: 72, y: 105 },
          { x: 100, y: 70 },
          { x: 170, y: 70 },
          { x: 198, y: 105 },
          { x: 198, y: 300 }
        ]
      }
    ]
  },

  dtf: {
       front: [
      {
        x: 92,
        y: 160,
        w: 72,
        h: 120,
        label: 'Front Left',
        maxW: 5,
        maxH: 9,
        points: [
          { x: 55, y: 190 },
          { x: 55, y: 115 },
          { x: 90, y: 75 },
          { x: 130, y: 75 },
          { x: 130, y: 190 }
        ]
      },
      {
        x: 178,
        y: 160,
        w: 72,
        h: 120,
        label: 'Front Right',
        maxW: 5,
        maxH: 9,
        points: [
          { x: 140, y: 75 },
          { x: 180, y: 75 },
          { x: 215, y: 115 },
          { x: 215, y: 190 },
          { x: 140, y: 190 }
        ]
      }
    ],
    back: [
      {
        x: 135,
        y: 230,
        w: 185,
        h: 220,
        label: 'Back',
        maxW: 12,
        maxH: 18,
        points: [
          { x: 72, y: 300 },
          { x: 72, y: 105 },
          { x: 100, y: 70 },
          { x: 170, y: 70 },
          { x: 198, y: 105 },
          { x: 198, y: 300 }
        ]
      }
    ]
  }
},

'jacket': {
  dtg: {
    front: [
      { x: 135, y: 175, w: 185, h: 280, label: 'Chest', maxW: 16, maxH: 19 }
    ],
    back: [
      { x: 135, y: 175, w: 185, h: 280, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 175, w: 185, h: 280, label: 'Chest', maxW: 16, maxH: 19 }
    ],
    back: [
      { x: 135, y: 175, w: 185, h: 280, label: 'Back', maxW: 16, maxH: 19 }
    ]
  },

  embroidery: {
    front: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },
      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ],
    back: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },
      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
  },

  sleeve: {
    leftSleeve: [
      { x: 135, y: 250, w: 250, h: 260, label: 'Left Sleeve', maxW: 4, maxH: 4 }
    ],
    rightSleeve: [
      { x: 135, y: 250, w: 250, h: 260, label: 'Right Sleeve', maxW: 4, maxH: 4 }
    ]
  }
},

  'sweatshirt': {
    dtg: { front: [
      { x: 135, y: 195, w: 185, h: 250, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 195, w: 185, h: 250, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    dtf: { front: [
      { x: 135, y: 195, w: 185, h: 250, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 195, w: 185, h: 250, label: 'Chest', maxW: 16, maxH: 19  }
    ]
    },

    embroidery: {
      front: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ] ,
    back: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
    },

    sleeve: { leftSleeve: [
      { x: 200, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ], rightSleeve: [
      { x: 100, y: 240, w: 110, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
    }
   },

  'long-sleeve': {
    dtg: { front: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    dtf: { front: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    embroidery: {
      front: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 200, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ] ,
    back: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 200, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
    },

    sleeve: { leftSleeve: [
      { x: 200, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ], rightSleeve: [
      { x: 100, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
    }
   },

   'snow-washed-tank-top': {
  dtg: {
    front: [
      { x: 135, y: 180, w: 120, h: 230, label: 'Front', maxW: 12, maxH: 16 }
    ],
    back: [
      { x: 135, y: 170, w: 100, h: 220, label: 'Back', maxW: 11, maxH: 14 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 190, w: 95, h: 190, label: 'Front', maxW: 4.5, maxH: 9 }
    ],
    back: [
      { x: 135, y: 200, w: 95, h: 220, label: 'Back', maxW: 4.5, maxH: 11 }
    ]
  }
},

'snow-washed-frayed-hem-tank-top': {
  dtg: {
    front: [
      { x: 135, y: 150, w: 160, h: 200, label: 'Front', maxW: 12, maxH: 16 }
    ],
    back: [
      { x: 135, y: 170, w: 150, h: 210, label: 'Back', maxW: 11, maxH: 14 }
    ]
  },

  dtf: {
    front: [
      { x: 135, y: 320, w: 180, h: 240, label: 'Front', maxW: 12, maxH: 16 }
    ],
    back: [
      { x: 135, y: 200, w: 165, h: 210, label: 'Back', maxW: 11, maxH: 14 }
    ]
  }
},

'womens-pleated-halter-sports-bra': {

  dtg: {

    front: [

      {
        x: 40,
        y: 220,
        w: 55,
        h: 55,
        label: 'Left Upper',
        maxW: 2,
        maxH: 2
      },

      {
        x: 30,
        y: 305,
        w: 55,
        h: 55,
        label: 'Left Lower',
        maxW: 2,
        maxH: 2
      },

      {
        x: 230,
        y: 220,
        w: 55,
        h: 55,
        label: 'Right Upper',
        maxW: 2,
        maxH: 2
      },

      {
        x: 240,
        y: 305,
        w: 55,
        h: 55,
        label: 'Right Lower',
        maxW: 2,
        maxH: 2
      }

    ],

    back: [

      {
        x: 140,
        y: 350,
        w: 180,
        h: 20,
        label: 'Back Band',
        maxW: 6,
        maxH: 1
      }

    ]

  },

  dtf: {

    front: [

      {
                x: 40,
        y: 220,
        w: 55,
        h: 55,
        label: 'Left Upper',
        maxW: 2,
        maxH: 2
      },

      {
        x: 30,
        y: 305,
        w: 55,
        h: 55,
        label: 'Left Lower',
        maxW: 2,
        maxH: 2
      },

      {
        x: 230,
        y: 220,
        w: 55,
        h: 55,
        label: 'Right Upper',
        maxW: 2,
        maxH: 2
      },

      {
        x: 240,
        y: 305,
        w: 55,
        h: 55,
        label: 'Right Lower',
        maxW: 2,
        maxH: 2
      }

    ],

    back: [

      {
        x: 140,
        y: 350,
        w: 180,
        h: 20,
        label: 'Back Band',
        maxW: 6,
        maxH: 1
      }

    ],

  },

  embroidery: {

    front: [

      {
        x: 150,
        y: 150,
        w: 55,
        h: 55,
        label: 'Left Upper',
        maxW: 2,
        maxH: 2
      },

      {
        x: 150,
        y: 255,
        w: 55,
        h: 55,
        label: 'Left Lower',
        maxW: 2,
        maxH: 2
      },

      {
        x: 295,
        y: 150,
        w: 55,
        h: 55,
        label: 'Right Upper',
        maxW: 2,
        maxH: 2
      },

      {
        x: 295,
        y: 255,
        w: 55,
        h: 55,
        label: 'Right Lower',
        maxW: 2,
        maxH: 2
      }

    ],

    back: [

      {
        x: 160,
        y: 365,
        w: 180,
        h: 30,
        label: 'Back Band',
        maxW: 6,
        maxH: 1
      }

    ]

  }

},
'womens-cropped-sports-bra': {

  dtg: {
    front: [
      /* LEFT UPPER VERTICAL */
      {
        x: 38,
        y: 195,
        w: 22,
        h: 68,
        label: 'Left Chest',
        maxW: 2,
        maxH: 1,
      },

      /* RIGHT UPPER VERTICAL */
      {
        x: 232,
        y: 195,
        w: 22,
        h: 68,
        label: 'Right Chest',
        maxW: 2,
        maxH: 1,
      },

      /* CENTRE FRONT */
      {
        x: 137,
        y: 262,
        w: 125,
        h: 95,
        label: 'Front Centre',
        maxW: 4,
        maxH: 5,
      },

      /* FRONT LOWER BAND */
      {
        x: 165,
        y: 334,
        w: 340,
        h: 18,
        label: 'Front Band',
        maxW: 1,
        maxH: 1,
      }
    ],

    back: [
      /* CENTRE BACK VERTICAL */
      {
        x: 135,
        y: 180,
        w: 30,
        h: 130,
        label: 'Back Centre',
        maxW: 4,
        maxH: 1,
      },

      /* LARGE LOWER BACK */
      {
        x: 145,
        y: 290,
        w: 300,
        h: 30,
        label: 'Lower Back',
        maxW: 11,
        maxH: 02,
      },

      /* BACK LOWER BAND */
      {
        x: 165,
        y: 338,
        w: 400,
        h: 18,
        label: 'Back Band',
        maxW: 01,
        maxH: 01,
            }
    ]
  },

  dtf: {
      front: [
      /* LEFT UPPER VERTICAL */
      {
        x: 38,
        y: 195,
        w: 22,
        h: 68,
        label: 'Left Chest',
        maxW: 2,
        maxH: 1,
      },

      /* RIGHT UPPER VERTICAL */
      {
        x: 232,
        y: 195,
        w: 22,
        h: 68,
        label: 'Right Chest',
        maxW: 2,
        maxH: 1,
      },

      /* CENTRE FRONT */
      {
        x: 137,
        y: 262,
        w: 125,
        h: 95,
        label: 'Front Centre',
        maxW: 4,
        maxH: 5,
      },

      /* FRONT LOWER BAND */
      {
        x: 165,
        y: 334,
        w: 340,
        h: 18,
        label: 'Front Band',
        maxW: 1,
        maxH: 1,
      }
    ],

    back: [
      /* CENTRE BACK VERTICAL */
      {
        x: 135,
        y: 180,
        w: 30,
        h: 130,
        label: 'Back Centre',
        maxW: 4,
        maxH: 1,
      },

      /* LARGE LOWER BACK */
      {
        x: 145,
        y: 290,
        w: 300,
        h: 30,
        label: 'Lower Back',
        maxW: 11,
        maxH: 02,
      },

      /* BACK LOWER BAND */
      {
        x: 165,
        y: 338,
        w: 400,
        h: 18,
        label: 'Back Band',
        maxW: 01,
        maxH: 01,
      }
    ]
  }

},
'womens-topstitching-yoga-tank-top': {

  dtg: {

    front: [

      {
        x: 40,
        y: 165,
        w: 75,
        h: 35,
        label: 'Left Upper',
        maxW: 3,
        maxH: 1.5
      },

      {
        x: 225,
        y: 165,
        w: 75,
        h: 35,
        label: 'Right Upper',
        maxW: 3,
        maxH: 1.5
      },

     {
     
        x: 130,
        y: 280,
        w: 180,
        h: 150,
        label: 'Front Band',
        maxW: 9,
        maxH: 5
      }

    ],

    back: [

      {
        x: 130,
        y: 300,
        w: 180,
        h: 150,
        label: 'Front Band',
        maxW: 9,
        maxH: 5,
      }

    ]

  },

  dtf: {

       front: [

      {
        x: 40,
        y: 165,
        w: 75,
        h: 35,
        label: 'Left Upper',
        maxW: 3,
        maxH: 1.5
      },

      {
        x: 225,
        y: 165,
        w: 75,
        h: 35,
        label: 'Right Upper',
        maxW: 3,
        maxH: 1.5
      },

     {
     
        x: 130,
        y: 280,
        w: 180,
        h: 150,
        label: 'Front Band',
        maxW: 9,
        maxH: 5
      }

    ],

    back: [

      {
        x: 130,
        y: 300,
        w: 180,
        h: 150,
        label: 'Front Band',
        maxW: 9,
        maxH: 5,
      
      }

    ]

  },

  embroidery: {

    front: [

      {
        x: 45,
        y: 135,
        w: 85,
        h: 45,
        label: 'Left Upper',
        maxW: 3,
        maxH: 1.5
      },

      {
        x: 230,
        y: 135,
        w: 85,
        h: 45,
        label: 'Right Upper',
        maxW: 3,
        maxH: 1.5
      },

      {
        x: 45,
        y: 235,
        w: 70,
        h: 70,
        label: 'Left Lower',
        maxW: 2,
        maxH: 2
      },

      {
        x: 245,
        y: 235,
        w: 70,
        h: 70,
        label: 'Right Lower',
        maxW: 2,
        maxH: 2
      },

      {
        x: 95,
        y: 335,
        w: 180,
        h: 24,
        label: 'Front Band',
        maxW: 6,
        maxH: 0.8
      }

    ],

    back: [

      {
        x: 65,
        y: 255,
        w: 70,
        h: 40,
        label: 'Left Back',
        maxW: 2,
        maxH: 1.5
      },

      {
        x: 225,
        y: 255,
        w: 70,
        h: 40,
        label: 'Right Back',
        maxW: 2,
        maxH: 1.5
      },

      {
        x: 95,
        y: 335,
        w: 180,
        h: 24,
        label: 'Back Band',
        maxW: 6,
        maxH: 0.8
      }

    ]

  }

},

'womens-halter-cropped-sports-bra': {

  dtg: {
    front: [

      {
        x: 35,
        y: 260,
        w: 70,
        h: 70,
        label: 'Left Lower',
        maxW: 2,
        maxH: 2
      },

      {
        x: 235,
        y: 260,
        w: 70,
        h: 70,
        label: 'Right Lower',
        maxW: 2,
        maxH: 2
      },

      {
        x: 135,
        y: 350,
        w: 220,
        h: 20,
        label: 'Bottom Band',
        maxW: 6,
        maxH: 1
      }

    ],

    back: [

      {
        x: 30,
        y: 300,
        w: 60,
        h: 35,
        label: 'Left',
        maxW: 2,
        maxH: 1
      },

      {
        x: 240,
        y: 300,
        w: 60,
        h: 35,
        label: 'Right',
        maxW: 2,
        maxH: 1
      },

      {
        x: 130,
        y: 345,
        w: 220,
        h: 20,
        label: 'Bottom Band',
        maxW: 6,
        maxH: 1,
      }

    ]

  },
dtf: {
  front: [

    {
      x: 35,
      y: 260,
      w: 70,
      h: 70,
      label: 'Left Lower',
      maxW: 2,
      maxH: 2
    },

    {
      x: 235,
      y: 260,
      w: 70,
      h: 70,
      label: 'Right Lower',
      maxW: 2,
      maxH: 2
    },

    {
      x: 135,
      y: 350,
      w: 220,
      h: 20,
      label: 'Bottom Band',
      maxW: 6,
      maxH: 1
    }

  ],

  back: [

    {
      x: 30,
      y: 300,
      w: 60,
      h: 35,
      label: 'Left',
      maxW: 2,
      maxH: 1
    },

    {
      x: 240,
      y: 300,
      w: 60,
      h: 35,
      label: 'Right',
      maxW: 2,
      maxH: 1
    },

    {
      x: 130,
      y: 345,
      w: 220,
      h: 20,
      label: 'Bottom Band',
      maxW: 6,
      maxH: 1
    }

  ]

  }

},

'womens-quarter-zip-yoga-romper': {

  dtg: {
    front: [

      {
        x: 100,
        y: 130,
        w: 40,
        h: 190,
        label: 'Left Front',
        maxW: 2,
        maxH: 13
      },

      {
        x: 170,
        y: 130,
        w: 40,
        h: 190,
        label: 'Right Front',
        maxW: 2,
        maxH: 13
      },

      {
        x: 75,
        y: 350,
        w: 40,
        h: 70,
        rotate: 6,
        label: 'Left Leg',
        maxW: 4,
        maxH: 2
      },

      {
        x: 195,
        y: 350,
        w: 40,
        h: 70,
        rotate: -6,
        label: 'Right Leg',
        maxW: 4,
        maxH: 2
      }

    ],

    back: [

      {
        x: 135,
        y: 35,
        w: 28,
        h: 70,
        label: 'Upper Back',
        maxW: 1,
        maxH: 3
      },

      {
         x: 75,
        y: 250,
        w: 70,
        h: 40,
        label: 'Left Back',
        maxW: 1,
        maxH: 1
      },

      {
       x: 195,
        y: 250,
        w: 70,
        h: 40,
        label: 'Right Back',
        maxW: 1,
        maxH: 1
      },

      {
        x: 65,
        y: 350,
        w: 40,
        h: 70,
        rotate: 6,
        label: 'Left Leg',
        maxW: 4,
        maxH: 2
      },

      {
        x: 205,
        y: 350,
        w: 40,
        h: 70,
        rotate: -6,
        label: 'Right Leg',
        maxW: 4,
        maxH: 2
      }

    ]
  },

  dtf: {
    front: [

      {
           x: 100,
        y: 130,
        w: 40,
        h: 190,
        label: 'Left Front',
        maxW: 2,
        maxH: 13
      },

      {
        x: 170,
        y: 130,
        w: 40,
        h: 190,
        label: 'Right Front',
        maxW: 2,
        maxH: 13
      },

      {
        x: 75,
        y: 350,
        w: 40,
        h: 70,
        rotate: 6,
        label: 'Left Leg',
        maxW: 4,
        maxH: 2
      },

      {
        x: 195,
        y: 350,
        w: 40,
        h: 70,
        rotate: -6,
        label: 'Right Leg',
        maxW: 4,
        maxH: 2
      }

    ],

    back: [

      {
        x: 135,
        y: 35,
        w: 28,
        h: 70,
        label: 'Upper Back',
        maxW: 1,
        maxH: 3
      },

      {
         x: 75,
        y: 250,
        w: 70,
        h: 40,
        label: 'Left Back',
        maxW: 1,
        maxH: 1
      },

      {
       x: 195,
        y: 250,
        w: 70,
        h: 40,
        label: 'Right Back',
        maxW: 1,
        maxH: 1
      },

      {
        x: 65,
        y: 350,
        w: 40,
        h: 70,
        rotate: 6,
        label: 'Left Leg',
        maxW: 4,
        maxH: 2
      },

      {
        x: 205,
        y: 350,
        w: 40,
        h: 70,
        rotate: -6,
        label: 'Right Leg',
        maxW: 4,
        maxH: 2
      }

    ]
  }

},
'womens-u-neck-yoga-romper': {

  dtg: {

    front: [

      {
        x: 135,
        y: 125,
        w: 150,
        h: 120,
        label: 'Chest',
        maxW: 8,
        maxH: 7
      },

      {
        x: 65,
        y: 350,
        w: 70,
        h: 70,
        rotate: 5,
        label: 'Left Leg',
        maxW: 4,
        maxH: 6
      },

      {
        x: 210,
        y: 350,
        w: 70,
        h: 70,
        rotate: -5,
        label: 'Right Leg',
        maxW: 4,
        maxH: 6
      }

    ],

    back: [

      {
        x: 140,
        y: 145,
        w: 180,
        h: 60,
        label: 'Upper Back',
        maxW: 10,
        maxH: 4
      },

      {
         x: 65,
        y: 350,
        w: 70,
        h: 70,
        rotate: 5,
        label: 'Left Leg',
        maxW: 4,
        maxH: 6
      },

      {
      x: 210,
        y: 350,
        w: 70,
        h: 70,
        rotate: -5,
        label: 'Right Leg',
        maxW: 4,
        maxH: 6
      }

    ]

  },

  dtf: {

    front: [

      {
                x: 135,
        y: 125,
        w: 150,
        h: 120,
        label: 'Chest',
        maxW: 8,
        maxH: 7
      },

      {
        x: 65,
        y: 350,
        w: 70,
        h: 70,
        rotate: 5,
        label: 'Left Leg',
        maxW: 4,
        maxH: 6
      },

      {
        x: 210,
        y: 350,
        w: 70,
        h: 70,
        rotate: -5,
        label: 'Right Leg',
        maxW: 4,
        maxH: 6
      }

    ],

    back: [

      {
        x: 140,
        y: 145,
        w: 180,
        h: 60,
        label: 'Upper Back',
        maxW: 10,
        maxH: 4
      },

      {
         x: 65,
        y: 350,
        w: 70,
        h: 70,
        rotate: 5,
        label: 'Left Leg',
        maxW: 4,
        maxH: 6
      },

      {
      x: 210,
        y: 350,
        w: 70,
        h: 70,
        rotate: -5,
        label: 'Right Leg',
        maxW: 4,
        maxH: 6
      }

    ]

  },

  embroidery: {

    front: [

      {
        x: 120,
        y: 80,
        w: 110,
        h: 110,
        label: 'Chest',
        maxW: 4,
        maxH: 4
      }

    ],

    back: [

      {
        x: 120,
        y: 90,
        w: 110,
        h: 60,
        label: 'Upper Back',
        maxW: 4,
        maxH: 2
      }

    ]

  }

},
  'tank-top': {
    dtg: { front: [
      { x: 135, y: 170, w: 190, h: 230, label: 'Chest', maxW: 14, maxH: 18 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 230, label: 'Back', maxW: 16, maxH: 21 }
    ]
    },

    dtf: { front: [
      { x: 135, y: 170, w: 190, h: 230, label: 'Chest', maxW: 14, maxH: 18 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 230, label: 'Back', maxW: 16, maxH: 21 }
    ]
    },

    embroidery: {
      front: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 200, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ] ,
    back: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 200, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
    }
   },

   'unisex-plaid-wide-leg-pants': {
  dtg: {
    front: [
      { x: 65, y: 200, w: 105, h: 160, rotate: 6, label: 'Front Left Leg', maxW: 9, maxH: 9 },
      { x: 200, y: 200, w: 105, h: 160, rotate: -6, label: 'Front Right Leg', maxW: 9, maxH: 9 }
    ],
    back: [
      { x: 65, y: 190, w: 100, h: 190, rotate: 5, label: 'Back Left Leg', maxW: 9, maxH: 15 },
      { x: 200, y: 190, w: 100, h: 190, rotate: -5, label: 'Back Right Leg', maxW: 9, maxH: 15 },
      { x: 190, y: 40, w: 45, h: 45, rotate: -5, label: 'Pocket', maxW: 3, maxH: 3 }
    ]
  },

  dtf: {
    front: [
      { x: 65, y: 200, w: 105, h: 160, rotate: 6, label: 'Front Left Leg', maxW: 9, maxH: 9 },
      { x: 200, y: 200, w: 105, h: 160, rotate: -6, label: 'Front Right Leg', maxW: 9, maxH: 9 }
    ],
    back: [
      { x: 65, y: 190, w: 100, h: 190, rotate: 5, label: 'Back Left Leg', maxW: 9, maxH: 15 },
      { x: 200, y: 190, w: 100, h: 190, rotate: -5, label: 'Back Right Leg', maxW: 9, maxH: 15 },
      { x: 190, y: 40, w: 45, h: 45, rotate: -5, label: 'Pocket', maxW: 3, maxH: 3 }
    ]
  }
},

'unisex-striped-pleated-pants': {
  dtg: {
    front: [
      { x: 82, y: 140, w: 78, h: 150, rotate: 4, label: 'Left Upper', maxW: 7, maxH: 14 },
      { x: 70, y: 300, w: 78, h: 150, rotate: 4, label: 'Left Lower', maxW: 7, maxH: 14 },
      { x: 185, y: 140, w: 78, h: 150, rotate: -4, label: 'Right Upper', maxW: 7, maxH: 14 },
      { x: 200, y: 300, w: 78, h: 150, rotate: -4, label: 'Right Lower', maxW: 7, maxH: 14 }
    ],
    back: [
       { x: 82, y: 140, w: 78, h: 150, rotate: 4, label: 'Left Upper', maxW: 7, maxH: 14 },
      { x: 70, y: 300, w: 78, h: 150, rotate: 4, label: 'Left Lower', maxW: 7, maxH: 14 },
      { x: 185, y: 140, w: 78, h: 150, rotate: -4, label: 'Right Upper', maxW: 7, maxH: 14 },
      { x: 200, y: 300, w: 78, h: 150, rotate: -4, label: 'Right Lower', maxW: 7, maxH: 14 }
    ]
  },

  dtf: {
    front: [
      { x: 82, y: 140, w: 78, h: 150, rotate: 4, label: 'Left Upper', maxW: 7, maxH: 14 },
      { x: 70, y: 300, w: 78, h: 150, rotate: 4, label: 'Left Lower', maxW: 7, maxH: 14 },
      { x: 185, y: 140, w: 78, h: 150, rotate: -4, label: 'Right Upper', maxW: 7, maxH: 14 },
      { x: 200, y: 300, w: 78, h: 150, rotate: -4, label: 'Right Lower', maxW: 7, maxH: 14 }
    ],
   back: [
       { x: 82, y: 140, w: 78, h: 150, rotate: 4, label: 'Left Upper', maxW: 7, maxH: 14 },
      { x: 70, y: 300, w: 78, h: 150, rotate: 4, label: 'Left Lower', maxW: 7, maxH: 14 },
      { x: 185, y: 140, w: 78, h: 150, rotate: -4, label: 'Right Upper', maxW: 7, maxH: 14 },
      { x: 200, y: 300, w: 78, h: 150, rotate: -4, label: 'Right Lower', maxW: 7, maxH: 14 }
    ]
  }
},

'striped-waist-wide-leg-pants': {
  dtg: {
    front: [
      { x: 78, y: 150, w: 70, h: 110, rotate: 8, label: 'Front Left Upper', maxW: 6, maxH: 9 },
      { x: 66, y: 310, w: 70, h: 110, rotate: 8, label: 'Front Left Lower', maxW: 6, maxH: 9 },

      { x: 192, y: 150, w: 70, h: 110, rotate: -8, label: 'Front Right Upper', maxW: 6, maxH: 9 },
      { x: 204, y: 310, w: 70, h: 110, rotate: -8, label: 'Front Right Lower', maxW: 6, maxH: 9 }
    ],
    back: [
      { x: 78, y: 150, w: 75, h: 170, rotate: 7, label: 'Back Left Large', maxW: 7, maxH: 17 },
      { x: 55, y: 300, w: 70, h: 110, rotate: 7, label: 'Back Left Lower', maxW: 6, maxH: 9 },

      { x: 190, y: 150, w: 70, h: 120, rotate: -7, label: 'Back Right Upper', maxW: 6, maxH: 9 },
      { x: 205, y: 300, w: 70, h: 110, rotate: -5, label: 'Back Right Lower', maxW: 6, maxH: 9 },

      { x: 180, y: 45, w: 45, h: 45, rotate: -5, label: 'Back Pocket', maxW: 3, maxH: 3 }
    ]
  },

  dtf: {
    front: [
      { x: 78, y: 150, w: 70, h: 110, rotate: 8, label: 'Front Left Upper', maxW: 6, maxH: 9 },
      { x: 66, y: 310, w: 70, h: 110, rotate: 8, label: 'Front Left Lower', maxW: 6, maxH: 9 },

      { x: 192, y: 150, w: 70, h: 110, rotate: -8, label: 'Front Right Upper', maxW: 6, maxH: 9 },
      { x: 204, y: 310, w: 70, h: 110, rotate: -8, label: 'Front Right Lower', maxW: 6, maxH: 9 }
    ],
    back: [
      { x: 78, y: 205, w: 75, h: 210, rotate: 7, label: 'Back Left Large', maxW: 7, maxH: 17 },
      { x: 70, y: 390, w: 70, h: 110, rotate: 5, label: 'Back Left Lower', maxW: 6, maxH: 9 },

      { x: 205, y: 215, w: 70, h: 120, rotate: -7, label: 'Back Right Upper', maxW: 6, maxH: 9 },
      { x: 205, y: 390, w: 70, h: 110, rotate: -5, label: 'Back Right Lower', maxW: 6, maxH: 9 },

      { x: 185, y: 80, w: 45, h: 45, rotate: -5, label: 'Back Pocket', maxW: 3, maxH: 3 }
    ]
  }
},
'womens-color-block-a-line-skirt': {

  dtg: {

    front: [

    {
        x: 155,
        y: 190,
        w: 130,
        h: 190,
        rotate: -3,
        label: 'Front',
        maxW: 4,
        maxH: 8
      }

    ],

 back: [

  {
    x: 130,
    y: 195,
    w: 240,
    h: 190,
    label: 'Back',
    maxW: 10,
    maxH: 8
  }

]

  },

  dtf: {

     front: [

    {
        x: 155,
        y: 190,
        w: 130,
        h: 190,
        rotate: -3,
        label: 'Front',
        maxW: 4,
        maxH: 8
      }

    ],

 back: [

  {
    x: 130,
    y: 195,
    w: 240,
    h: 190,
    label: 'Back',
    maxW: 10,
    maxH: 8
      }

    ]

  },

  embroidery: {

    front: [

      {
        x: 125,
        y: 18,
        w: 100,
        h: 24,
        label: 'Waist',
        maxW: 4,
        maxH: 1
      },

      {
        x: 48,
        y: 105,
        w: 48,
        h: 120,
        rotate: 8,
        label: 'Side Panel',
        maxW: 2,
        maxH: 5
      },

      {
        x: 165,
        y: 80,
        w: 120,
        h: 190,
        rotate: -3,
        label: 'Front',
        maxW: 4,
        maxH: 8
      }

    ],

    back: [

      {
        x: 125,
        y: 18,
        w: 100,
        h: 24,
        label: 'Waist',
        maxW: 4,
        maxH: 1
      },

      {
        x: 80,
        y: 75,
        w: 240,
        h: 190,
        label: 'Back',
        maxW: 10,
        maxH: 8
      }

    ]

  }

},
  'pants': {
    dtg: { front: [
      { x: 135, y: 170, w: 190, h: 250, label: '', maxW: 12, maxH: 16 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 250, label: '', maxW: 12, maxH: 16 }
    ]
    },

    dtf: { front: [
      { x: 135, y: 170, w: 190, h: 250, label: '', maxW: 12, maxH: 16 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 250, label: '', maxW: 12, maxH: 16 }
    ]
    },

    embroidery: {
      front: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 }
    ] ,
    back: [
      { x: 135, y: 115, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 155, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 }
    ]
    }
   },

   'reverse-dyed-sweatshorts': {
  dtg: {
    front: [
      { x: 65, y: 275, w: 110, h: 132, rotate: 8, label: '', maxW: 7, maxH: 10 },
      { x: 210, y: 275, w: 110, h: 132, rotate: -8, label: '', maxW: 7, maxH: 10 }
    ],
    back: [
      { x: 55, y: 275, w: 92, h: 132, rotate: 8, label: '', maxW: 7, maxH: 10 }
    ]
  },

  dtf: {
    front: [
      { x: 65, y: 275, w: 110, h: 132, rotate: 8, label: '', maxW: 7, maxH: 10 },
      { x: 210, y: 275, w: 110, h: 132, rotate: -8, label: '', maxW: 7, maxH: 10 }
    ],
    back: [
      { x: 55, y: 275, w: 92, h: 132, rotate: 8, label: '', maxW: 7, maxH: 10 }
    ]
  }
},

'essential-heavyweight-fleece-shorts': {
  dtg: {
    front: [
      { x: 60, y: 270, w: 100, h: 160, rotate: 8, label: '', maxW: 7, maxH: 10 },
      { x: 200, y: 270, w: 100, h: 160, rotate: -8, label: '', maxW: 7, maxH: 10 }
    ],
    back: [
       { x: 60, y: 270, w: 100, h: 160, rotate: 8, label: '', maxW: 7, maxH: 10 },
      { x: 210, y: 270, w: 100, h: 160, rotate: -8, label: '', maxW: 7, maxH: 10 }
    ]
  },

  dtf: {
    front: [
       { x: 60, y: 270, w: 100, h: 160, rotate: 8, label: '', maxW: 7, maxH: 10 },
      { x: 200, y: 270, w: 100, h: 160, rotate: -8, label: '', maxW: 7, maxH: 10 }
    ],
    back: [
       { x: 60, y: 270, w: 100, h: 160, rotate: 8, label: '', maxW: 7, maxH: 10 },
      { x: 200, y: 270, w: 100, h: 160, rotate: -8, label: '', maxW: 7, maxH: 10 }
    ]
  },

  embroidery: {
    front: [
      { x: 135, y: 155, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 }
    ],
    back: [
      { x: 135, y: 155, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 }
    ]
  }
},

'unisex-vintage-wash-mesh-shorts': {
  dtg: {
    front: [
      {
        x: 88,
        y: 220,
        w: 285,
        h: 150,
        rotate: 5,
        label: 'Front Left',
        maxW: 7,
        maxH: 12,
        measureW: 7,
        measureH: 12,
        points: [
          { x: 20, y: 320 },
          { x: 47, y: 170 },
          { x: 120, y: 190 },
          { x: 93, y: 345 }
        ]
      },
      {
  x: 182,
y: 220,
w: 285,
h: 150,
rotate: -5,
label: 'Front Right',
maxW: 7,
maxH: 12,
measureW: 7,
measureH: 12,
points: [
  { x: 250, y: 320 },
  { x: 223, y: 170 },
  { x: 150, y: 190 },
  { x: 177, y: 345 }
        ]
      }
    ],
    back: [
      {
       x: 88,
    y: 220,
    w: 245,
    h: 100,
    rotate: 5,
    label: 'Back Left',
    maxW: 6,
    maxH: 11,
    measureW: 6,
    measureH: 11,
    points: [
      { x: 30, y: 335 },
      { x: 55, y: 200 },
      { x: 120, y: 220 },
      { x: 95, y: 355 }
    ]
  },
  {
    x: 182,
    y: 220,
    w: 245,
    h: 100,
    rotate: -5,
    label: 'Back Right',
    maxW: 6,
    maxH: 11,
    measureW: 6,
    measureH: 11,
    points: [
      { x: 240, y: 335 },
      { x: 215, y: 200 },
      { x: 150, y: 220 },
      { x: 175, y: 355 }
        ]
      }
    ]
  },

  dtf: {
        front: [
      {
        x: 88,
        y: 220,
        w: 285,
        h: 150,
        rotate: 5,
        label: 'Front Left',
        maxW: 7,
        maxH: 12,
        measureW: 7,
        measureH: 12,
        points: [
          { x: 20, y: 320 },
          { x: 47, y: 170 },
          { x: 120, y: 190 },
          { x: 93, y: 345 }
        ]
      },
      {
  x: 182,
y: 220,
w: 285,
h: 150,
rotate: -5,
label: 'Front Right',
maxW: 7,
maxH: 12,
measureW: 7,
measureH: 12,
points: [
  { x: 250, y: 320 },
  { x: 223, y: 170 },
  { x: 150, y: 190 },
  { x: 177, y: 345 }
        ]
      }
    ],
    back: [
      {
       x: 88,
    y: 220,
    w: 245,
    h: 100,
    rotate: 5,
    label: 'Back Left',
    maxW: 6,
    maxH: 11,
    measureW: 6,
    measureH: 11,
    points: [
      { x: 30, y: 335 },
      { x: 55, y: 200 },
      { x: 120, y: 220 },
      { x: 95, y: 355 }
    ]
  },
  {
    x: 182,
    y: 220,
    w: 245,
    h: 100,
    rotate: -5,
    label: 'Back Right',
    maxW: 6,
    maxH: 11,
    measureW: 6,
    measureH: 11,
    points: [
      { x: 240, y: 335 },
      { x: 215, y: 200 },
      { x: 150, y: 220 },
      { x: 175, y: 355 }
    ]
  }
]
  }
},
'mens-regular-fit-performance-shorts': {

  dtg: {
    front: [
      {
        x: 62,
        y: 245,
        w: 95,
        h: 170,
        rotate: 12,
        label: 'Left Leg',
        maxW: 7,
        maxH: 10
      },
      {
        x: 220,
        y: 245,
        w: 95,
        h: 170,
        rotate: -12,
        label: 'Right Leg',
        maxW: 7,
        maxH: 10
      }
    ],

    back: [
      {
              x: 62,
        y: 245,
        w: 95,
        h: 170,
        rotate: 12,
        label: 'Left Leg',
        maxW: 7,
        maxH: 10
      },
      {
        x: 220,
        y: 245,
        w: 95,
        h: 170,
        rotate: -12,
        label: 'Right Leg',
        maxW: 7,
        maxH: 10
      }
    ]
  },

  dtf: {
      front: [
      {
        x: 62,
        y: 245,
        w: 95,
        h: 170,
        rotate: 12,
        label: 'Left Leg',
        maxW: 7,
        maxH: 10
      },
      {
        x: 220,
        y: 245,
        w: 95,
        h: 170,
        rotate: -12,
        label: 'Right Leg',
        maxW: 7,
        maxH: 10
      }
    ],

    back: [
      {
              x: 62,
        y: 245,
        w: 95,
        h: 170,
        rotate: 12,
        label: 'Left Leg',
        maxW: 7,
        maxH: 10
      },
      {
        x: 220,
        y: 245,
        w: 95,
        h: 170,
        rotate: -12,
        label: 'Right Leg',
        maxW: 7,
        maxH: 10
      }
    ]
  }

},

'shorts': {
  dtg: {
    front: [
      { x: 55, y: 245, w: 100, h: 115, label: '', maxW: 11, maxH: 7 },
      { x: 220, y: 245, w: 100, h: 115, label: '', maxW: 11, maxH: 7 }
    ],
    back: [
      { x: 55, y: 245, w: 100, h: 115, label: '', maxW: 11, maxH: 7 },
      { x: 220, y: 245, w: 100, h: 115, label: '',maxW: 11, maxH: 7 }
    ]
  },

  dtf: {
    front: [
       { x: 55, y: 245, w: 100, h: 115, label: '', maxW: 11, maxH: 7 },
      { x: 220, y: 245, w: 100, h: 115, label: '', maxW: 11, maxH: 7 }
    ],
    back: [
       { x: 55, y: 245, w: 100, h: 115, label: '', maxW: 11, maxH: 7 },
      { x: 220, y: 245, w: 100, h: 115, label: '', maxW: 11, maxH: 7 }
    ]
  },

  embroidery: {
    front: [
      { x: 135, y: 155, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 190, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 }
    ],
    back: [
      { x: 135, y: 155, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },
      { x: 135, y: 190, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 }
    ]
  }
},


  // Sweatpants edit codes:
  // F/B = Front/Back, L/R = Left/Right, U/L = Upper/Lower, POCKET = pocket area.
  // Example: FRLPOCKET = Front Right Leg Pocket, FLLLEG = Front Left Lower Leg.
  'sunfade-wide-leg-fleece-sweatpants': {
    dtg: {
      front: [
        { code: 'FLLPOCKET', x: 95, y: 85, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'FRLPOCKET', x: 185, y: 85, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'FLULEG', x: 92, y: 155, w: 74, h: 110, label: '', maxW: 7, maxH: 12 },
        { code: 'FRULEG', x: 180, y: 155, w: 74, h: 110, label: '', maxW: 7, maxH: 12 },
        { code: 'FLLLEG', x: 78, y: 290, w: 65, h: 130, label: '', maxW: 7, maxH: 12 },
        { code: 'FRLLEG', x: 190, y: 290, w: 65, h: 130, label: '', maxW: 7, maxH: 12 }
      ],
      back: [
        { code: 'BLLPOCKET', x: 90, y: 90, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'BRLPOCKET', x: 180, y: 90, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'BLULEG', x: 92, y: 155, w: 74, h: 90, label: '', maxW: 7, maxH: 12 },
        { code: 'BRULEG', x: 180, y: 155, w: 74, h: 90, label: '', maxW: 7, maxH: 12 },
        { code: 'BLLLEG', x: 80, y: 290, w: 65, h: 120, label: '', maxW: 7, maxH: 12 },
        { code: 'BRLLEG', x: 188, y: 290, w: 65, h: 120, label: '', maxW: 7, maxH: 12 }
      ]
    },
    dtf: {
      front: [
        { code: 'FLLPOCKET', x: 95, y: 85, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'FRLPOCKET', x: 185, y: 85, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'FLULEG', x: 92, y: 155, w: 74, h: 110, label: '', maxW: 7, maxH: 12 },
        { code: 'FRULEG', x: 180, y: 155, w: 74, h: 110, label: '', maxW: 7, maxH: 12 },
        { code: 'FLLLEG', x: 78, y: 290, w: 65, h: 130, label: '', maxW: 7, maxH: 12 },
        { code: 'FRLLEG', x: 190, y: 290, w: 65, h: 130, label: '', maxW: 7, maxH: 12 }
      ],
      back: [
        { code: 'FLLPOCKET', x: 95, y: 85, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'FRLPOCKET', x: 185, y: 85, w: 50, h: 40, label: '', maxW: 3, maxH: 5 },
        { code: 'FLULEG', x: 92, y: 155, w: 74, h: 110, label: '', maxW: 7, maxH: 12 },
        { code: 'FRULEG', x: 180, y: 155, w: 74, h: 110, label: '', maxW: 7, maxH: 12 },
        { code: 'FLLLEG', x: 78, y: 290, w: 65, h: 130, label: '', maxW: 7, maxH: 12 },
        { code: 'FRLLEG', x: 190, y: 290, w: 65, h: 130, label: '', maxW: 7, maxH: 12 }
      ]
    }
  },

  'contrast-stitched-fleece-sweatpants': {
  dtg: {
    front: [
      { x: 80, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 },
      { x: 195, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 }
    ],
    back: [
      { x: 80, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 },
      { x: 195, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 }
    ]
  },

  dtf: {
    front: [
      { x: 80, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 },
      { x: 195, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 }
    ],
    back: [
      { x: 80, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 },
      { x: 195, y: 255, w: 62, h: 210, label: '', maxW: 6, maxH: 20 }
    ]
  }
},

'essential-heavyweight-cotton-sweatpants': {
  dtg: {
    front: [
      { x: 85, y: 150, w: 60, h: 110, label: '', maxW: 4, maxH: 8 },
      { x: 80, y: 295, w: 60, h: 110, label: '', maxW: 4, maxH: 8 },
      { x: 190, y: 150, w: 60, h: 110, label: '', maxW: 4, maxH: 8 },
      { x: 190, y: 295, w: 60, h: 110, label: '', maxW: 4, maxH: 8 }
    ],
    back: [
      { x: 80, y: 160, w: 65, h: 170, label: '', maxW: 5, maxH: 14 },
      { x: 180, y: 45, w: 50, h: 60, label: '', maxW: 3, maxH: 3 },
      { x: 195, y: 200, w: 58, h: 100, label: '', maxW: 3, maxH: 4 },
      { x: 75, y: 315, w: 58, h: 100, label: '', maxW: 3, maxH: 4 },
      { x: 195, y: 315, w: 58, h: 100, label: '', maxW: 3, maxH: 4 }
    ]
  },

  dtf: {
    front: [
      { x: 85, y: 170, w: 58, h: 78, label: '', maxW: 3, maxH: 4 },
      { x: 85, y: 295, w: 58, h: 78, label: '', maxW: 3, maxH: 4 },
      { x: 205, y: 170, w: 58, h: 78, label: '', maxW: 3, maxH: 4 },
      { x: 205, y: 295, w: 58, h: 155, label: '', maxW: 4, maxH: 14 }
    ],
    back: [
      { x: 75, y: 220, w: 72, h: 180, label: '', maxW: 5, maxH: 14 },
      { x: 205, y: 115, w: 58, h: 58, label: '', maxW: 3, maxH: 3 },
      { x: 205, y: 245, w: 58, h: 78, label: '', maxW: 3, maxH: 4 },
      { x: 75, y: 385, w: 58, h: 78, label: '', maxW: 3, maxH: 4 },
      { x: 205, y: 385, w: 58, h: 78, label: '', maxW: 3, maxH: 4 }
    ]
  }
},

'reflection-striped-straight-leg-sweatpants': {
  dtg: {
    front: [
      { x: 77, y: 275, w: 82, h: 210, rotate: 4, label: 'Front Left', maxW: 7, maxH: 15 },
      { x: 193, y: 275, w: 82, h: 210, rotate: -4, label: 'Front Right', maxW: 7, maxH: 15 }
    ],
    back: [
      { x: 77, y: 275, w: 82, h: 210, rotate: 4, label: 'Back Left', maxW: 7, maxH: 15 },
      { x: 193, y: 275, w: 82, h: 210, rotate: -4, label: 'Back Right', maxW: 7, maxH: 15 }
    ]
  },

  dtf: {
    front: [
      { x: 77, y: 275, w: 82, h: 210, rotate: 4, label: 'Front Left', maxW: 7, maxH: 15 },
      { x: 193, y: 275, w: 82, h: 210, rotate: -4, label: 'Front Right', maxW: 7, maxH: 15 }
    ],
    back: [
      { x: 77, y: 275, w: 82, h: 210, rotate: 4, label: 'Back Left', maxW: 7, maxH: 15 },
      { x: 193, y: 275, w: 82, h: 210, rotate: -4, label: 'Back Right', maxW: 7, maxH: 15 }
    ]
  }
},

'dirty-washed-fleece-sweatpants': {
  dtg: {
    front: [
      { x: 82, y: 130, w: 80, h: 115, label: 'Left Upper', maxW: 7, maxH: 10 },
      { x: 188, y: 130, w: 80, h: 115, label: 'Right Upper', maxW: 7, maxH: 10 },
      { x: 62, y: 300, w: 80, h: 125, label: 'Left Lower', maxW: 7, maxH: 11 },
      { x: 210, y: 300, w: 80, h: 125, label: 'Right Lower', maxW: 7, maxH: 11 }
    ],
    back: [
      { x: 85, y: 145, w: 80, h: 125, label: 'Back Left Upper', maxW: 7, maxH: 11 },
      { x: 65, y: 300, w: 80, h: 125, label: 'Back Left Lower', maxW: 7, maxH: 11 },
      { x: 205, y: 300, w: 80, h: 125, label: 'Back Right Lower', maxW: 7, maxH: 11 }
    ]
  },

  dtf: {
       front: [
      { x: 82, y: 130, w: 80, h: 115, label: 'Left Upper', maxW: 7, maxH: 10 },
      { x: 188, y: 130, w: 80, h: 115, label: 'Right Upper', maxW: 7, maxH: 10 },
      { x: 62, y: 300, w: 80, h: 125, label: 'Left Lower', maxW: 7, maxH: 11 },
      { x: 210, y: 300, w: 80, h: 125, label: 'Right Lower', maxW: 7, maxH: 11 }
    ],
    back: [
      { x: 85, y: 145, w: 80, h: 125, label: 'Back Left Upper', maxW: 7, maxH: 11 },
      { x: 65, y: 300, w: 80, h: 125, label: 'Back Left Lower', maxW: 7, maxH: 11 },
      { x: 205, y: 300, w: 80, h: 125, label: 'Back Right Lower', maxW: 7, maxH: 11 }
    ]
  }
},

'unisex-vintage-wash-wide-leg-mesh-sweatpants': {
  dtg: {
    front: [
      { x: 55, y: 120, w: 35, h: 75, rotate: 7, label: 'Front Left Outer', maxW: 7, maxH: 9 },
      { x: 90, y: 180, w: 55, h: 120, rotate: 7, label: 'Front Left Upper', maxW: 7, maxH: 14 },
      { x: 72, y: 320, w: 55, h: 120, rotate: 7, label: 'Front Left Lower', maxW: 7, maxH: 14 },

     { x: 215, y: 120, w: 35, h: 75, rotate: -7, label: 'Front Right Outer', maxW: 7, maxH: 9 },
{ x: 180, y: 180, w: 55, h: 120, rotate: -7, label: 'Front Right Upper', maxW: 7, maxH: 14 },
{ x: 198, y: 320, w: 55, h: 120, rotate: -7, label: 'Front Right Lower', maxW: 7, maxH: 14 },
    ],
    back: [
      { x: 82, y: 170, w: 65, h: 130, rotate: 6, label: 'Back Left Upper', maxW: 7, maxH: 15 },
      { x: 67, y: 320, w: 65, h: 130, rotate: 6, label: 'Back Left Lower', maxW: 7, maxH: 15 },

     { x: 188, y: 170, w: 65, h: 130, rotate: -6, label: 'Back Right Upper', maxW: 7, maxH: 15 },
{ x: 203, y: 320, w: 65, h: 130, rotate: -6, label: 'Back Right Lower', maxW: 7, maxH: 15 }
    ]
  },

  dtf: {
    front: [
           { x: 55, y: 120, w: 35, h: 75, rotate: 7, label: 'Front Left Outer', maxW: 7, maxH: 9 },
      { x: 90, y: 180, w: 55, h: 120, rotate: 7, label: 'Front Left Upper', maxW: 7, maxH: 14 },
      { x: 72, y: 320, w: 55, h: 120, rotate: 7, label: 'Front Left Lower', maxW: 7, maxH: 14 },

     { x: 215, y: 120, w: 35, h: 75, rotate: -7, label: 'Front Right Outer', maxW: 7, maxH: 9 },
{ x: 180, y: 180, w: 55, h: 120, rotate: -7, label: 'Front Right Upper', maxW: 7, maxH: 14 },
{ x: 198, y: 320, w: 55, h: 120, rotate: -7, label: 'Front Right Lower', maxW: 7, maxH: 14 },
    ],
    back: [
      { x: 82, y: 170, w: 65, h: 130, rotate: 6, label: 'Back Left Upper', maxW: 7, maxH: 15 },
      { x: 67, y: 320, w: 65, h: 130, rotate: 6, label: 'Back Left Lower', maxW: 7, maxH: 15 },

     { x: 188, y: 170, w: 65, h: 130, rotate: -6, label: 'Back Right Upper', maxW: 7, maxH: 15 },
{ x: 203, y: 320, w: 65, h: 130, rotate: -6, label: 'Back Right Lower', maxW: 7, maxH: 15 }
    ]
  }
},

'essential-drawstring-jogged-sweatpants': {
  dtg: {
    front: [
      { x: 78, y: 145, w: 55, h: 100, rotate: 2, label: 'Front Left Upper', maxW: 4.6, maxH: 9 },
      { x: 72, y: 285, w: 55, h: 100, rotate: 2, label: 'Front Left Lower', maxW: 4.6, maxH: 9 },

      { x: 192, y: 145, w: 55, h: 100, rotate: -2, label: 'Front Right Upper', maxW: 4.6, maxH: 9 },
      { x: 198, y: 285, w: 55, h: 100, rotate: -2, label: 'Front Right Lower', maxW: 4.6, maxH: 9 }
    ],
    back: [
      { x: 78, y: 135, w: 60, h: 120, rotate: 2, label: 'Back Left Upper', maxW: 5, maxH: 9 },
      { x: 72, y: 290, w: 60, h: 120, rotate: 2, label: 'Back Left Lower', maxW: 5, maxH: 9 },

      { x: 192, y: 135, w: 60, h: 120, rotate: -2, label: 'Back Right Upper', maxW: 5, maxH: 9 },
      { x: 198, y: 290, w: 60, h: 120, rotate: -2, label: 'Back Right Lower', maxW: 5, maxH: 9 }
    ]
  },

  dtf: {
      front: [
      { x: 78, y: 145, w: 55, h: 100, rotate: 2, label: 'Front Left Upper', maxW: 4.6, maxH: 9 },
      { x: 72, y: 285, w: 55, h: 100, rotate: 2, label: 'Front Left Lower', maxW: 4.6, maxH: 9 },

      { x: 192, y: 145, w: 55, h: 100, rotate: -2, label: 'Front Right Upper', maxW: 4.6, maxH: 9 },
      { x: 198, y: 285, w: 55, h: 100, rotate: -2, label: 'Front Right Lower', maxW: 4.6, maxH: 9 }
    ],
    back: [
      { x: 78, y: 135, w: 60, h: 120, rotate: 2, label: 'Back Left Upper', maxW: 5, maxH: 9 },
      { x: 72, y: 290, w: 60, h: 120, rotate: 2, label: 'Back Left Lower', maxW: 5, maxH: 9 },

      { x: 192, y: 135, w: 60, h: 120, rotate: -2, label: 'Back Right Upper', maxW: 5, maxH: 9 },
      { x: 198, y: 290, w: 60, h: 120, rotate: -2, label: 'Back Right Lower', maxW: 5, maxH: 9 }
    ]
  }
},
  'sweatpants': {
  dtg: {
    front: [
      { code: 'FLULEG', x: 65, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'FRULEG', x: 206, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'FLLLEG', x: 65, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'FRLLEG', x: 206, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12}
    ] ,
    back: [
      { code: 'BLULEG', x: 65, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'BRULEG', x: 206, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'BLLLEG', x: 65, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'BRLLEG', x: 206, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12}
    ]
    },

  dtf: {
    front: [
      { code: 'FLULEG', x: 65, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'FRULEG', x: 206, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'FLLLEG', x: 65, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'FRLLEG', x: 206, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12}
    ] ,
    back: [
      { code: 'BLULEG', x: 65, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'BRULEG', x: 206, y: 160, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'BLLLEG', x: 65, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12 },

      { code: 'BRLLEG', x: 206, y: 300, w: 78, h: 135, label: '', maxW: 7, maxH: 12}
    ]
    },

  embroidery: {
    front: [
      { code: 'FLEMB', x: 135, y: 115, w: 65, h: 65, label: '', maxW: 3, maxH: 3 },

      { code: 'FLEMBH', x: 135, y: 155, w: 160, h: 50, label: '', maxW: 3, maxH: 12 }
    ] ,
    back: [
      { code: 'BLEMB', x: 135, y: 115, w: 65, h: 65, label: '', maxW: 3, maxH: 3 },

      { code: 'BLEMBH', x: 135, y: 155, w: 160, h: 50, label: '', maxW: 3, maxH: 12 }
    ]
    }
 },

 'essential-drawstring-straight-leg-sweatpants': {
  dtg: {
    front: [
      { x: 86, y: 195, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 185, y: 195, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 80, y: 320, w: 75, h: 115, label: '', maxW: 7, maxH: 12 },
      { x: 195, y: 320, w: 75, h: 115, label: '', maxW: 7, maxH: 12 }
    ],
    back: [
   { x: 86, y: 195, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 185, y: 195, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 80, y: 320, w: 75, h: 115, label: '', maxW: 7, maxH: 12 },
      { x: 195, y: 320, w: 75, h: 115, label: '', maxW: 7, maxH: 12 }
    ]
  },

  dtf: {
    front: [
      { x: 86, y: 195, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 205, y: 195, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 86, y: 340, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 205, y: 340, w: 75, h: 125, label: '', maxW: 7, maxH: 12 }
    ],
    back: [
      { x: 72, y: 220, w: 75, h: 185, label: '', maxW: 7, maxH: 18 },
      { x: 205, y: 210, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 205, y: 365, w: 75, h: 125, label: '', maxW: 7, maxH: 12 },
      { x: 72, y: 390, w: 75, h: 125, label: '', maxW: 7, maxH: 12 }
    ]
  }
},

'womens-high-rise-flared-yoga-pants': {

  dtg: {

    front: [

      {
        x: 140,
        y: 20,
        w: 110,
        h: 50,
        label: 'Waist',
        maxW: 6,
        maxH: 3
      },

      {
        x: 65,
        y: 290,
        w: 50,
        h: 180,
        label: 'Left Leg',
        maxW: 4,
        maxH: 10
      },

      {
        x: 210,
        y: 290,
        w: 50,
        h: 180,
        label: 'Right Leg',
        maxW: 4,
        maxH: 10
      }

    ],

    back: [

      {
         x: 140,
        y: 20,
        w: 110,
        h: 50,
        label: 'Waist',
        maxW: 6,
        maxH: 3
      },

      {
        x: 65,
        y: 290,
        w: 50,
        h: 180,
        label: 'Left Leg',
        maxW: 4,
        maxH: 10
      },

      {
        x: 210,
        y: 290,
        w: 50,
        h: 180,
        label: 'Right Leg',
        maxW: 4,
        maxH: 10
      }

    ]

  },

  dtf: {

  front: [

    {
      x: 140,
      y: 20,
      w: 110,
      h: 50,
      label: 'Waist',
      maxW: 6,
      maxH: 3
    },

    {
      x: 65,
      y: 290,
      w: 50,
      h: 180,
      label: 'Left Leg',
      maxW: 4,
      maxH: 10
    },

    {
      x: 210,
      y: 290,
      w: 50,
      h: 180,
      label: 'Right Leg',
      maxW: 4,
      maxH: 10
    }

  ],

  back: [

    {
      x: 140,
      y: 20,
      w: 110,
      h: 50,
      label: 'Waist',
      maxW: 6,
      maxH: 3
    },

    {
      x: 65,
      y: 290,
      w: 50,
      h: 180,
      label: 'Left Leg',
      maxW: 4,
      maxH: 10
    },

    {
      x: 210,
      y: 290,
      w: 50,
      h: 180,
      label: 'Right Leg',
      maxW: 4,
      maxH: 10
    }

  ]

},

  embroidery: {

    front: [

      {
        x: 170,
        y: 55,
        w: 160,
        h: 75,
        label: 'Waist',
        maxW: 6,
        maxH: 3
      },

      {
        x: 90,
        y: 330,
        w: 90,
        h: 260,
        label: 'Left Leg',
        maxW: 4,
        maxH: 10
      },

      {
        x: 320,
        y: 330,
        w: 90,
        h: 260,
        label: 'Right Leg',
        maxW: 4,
        maxH: 10
      }

    ],

    back: [

      {
        x: 170,
        y: 55,
        w: 160,
        h: 75,
        label: 'Waist',
        maxW: 6,
        maxH: 3
      },

      {
        x: 90,
        y: 330,
        w: 90,
        h: 260,
        label: 'Left Leg',
        maxW: 4,
        maxH: 10
      },

      {
        x: 320,
        y: 330,
        w: 90,
        h: 260,
        label: 'Right Leg',
        maxW: 4,
        maxH: 10
      }

    ]

  }

},

  'straight-leg-sweatpants': {
  dtg: {
      front: [
      { code: 'FLULEG', x: 92, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'FRULEG', x: 185, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'FLLLEG', x: 79, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 },

      { code: 'FRLLEG', x: 188, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 }
    ] ,
    back: [
      { code: 'BLULEG', x: 92, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'BRULEG', x: 185, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'BLLLEG', x: 79, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 },

      { code: 'BRLLEG', x: 188, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 }
    ]
    },

    dtf: {
      front: [
    
      { code: 'FLULEG', x: 92, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'FRULEG', x: 185, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'FLLLEG', x: 79, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 },

      { code: 'FRLLEG', x: 188, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 }
    ] ,
    back: [
      { code: 'BLULEG', x: 92, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'BRULEG', x: 185, y: 160, w: 74, h: 120, label: '', maxW: 7, maxH: 12 },

      { code: 'BLLLEG', x: 79, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 },

      { code: 'BRLLEG', x: 188, y: 290, w: 74, h: 130, label: '', maxW: 7, maxH: 12 }
    ]
    },

    embroidery: {
      front: [
      { code: 'FLULEG', x: 92, y: 215, w: 78, h: 142, label: '', maxW: 7, maxH: 12 },

      { code: 'FRULEG', x: 226, y: 215, w: 78, h: 142, label: '', maxW: 7, maxH: 12 },

      { code: 'FLLLEG', x: 78, y: 365, w: 82, h: 145, label: '', maxW: 7, maxH: 12 },

      { code: 'FRLLEG', x: 240, y: 365, w: 82, h: 145, label: '', maxW: 7, maxH: 12 }
    ] ,
    back: [
      { code: 'BLULEG', x: 92, y: 215, w: 78, h: 142, label: '', maxW: 7, maxH: 12 },

      { code: 'BRULEG', x: 226, y: 215, w: 78, h: 142, label: '', maxW: 7, maxH: 12 },

      { code: 'BLLLEG', x: 78, y: 365, w: 82, h: 145, label: '', maxW: 7, maxH: 12 },

      { code: 'BRLLEG', x: 240, y: 365, w: 82, h: 145, label: '', maxW: 7, maxH: 12 }
    ]
    }
   },

  'three-quarter-sweatpants': {
    dtg: {
      front: [
      { code: 'FLLEG', x: 98, y: 260, w: 88, h: 190, label: '', maxW: 8, maxH: 14 },

      { code: 'FRLEG', x: 232, y: 260, w: 88, h: 190, label: '', maxW: 8, maxH: 14 }
    ] ,
    back: [
      { code: 'BLLEG', x: 92, y: 255, w: 88, h: 190, label: '', maxW: 8, maxH: 14 },

      { code: 'BRLEG', x: 238, y: 255, w: 88, h: 190, label: '', maxW: 8, maxH: 14 }
    ]
    },

    dtf: {
      front: [
      { code: 'FLLEG', x: 98, y: 260, w: 88, h: 190, label: '', maxW: 8, maxH: 14 },

      { code: 'FRLEG', x: 232, y: 260, w: 88, h: 190, label: '', maxW: 8, maxH: 14 }
    ] ,
    back: [
      { code: 'BLLEG', x: 92, y: 255, w: 88, h: 190, label: '', maxW: 8, maxH: 14 },

      { code: 'BRLEG', x: 238, y: 255, w: 88, h: 190, label: '', maxW: 8, maxH: 14 }
    ]
    },

    embroidery: {
      front: [
      { code: 'FLLEG', x: 98, y: 260, w: 88, h: 190, label: '', maxW: 8, maxH: 14 },

      { code: 'FRLEG', x: 232, y: 260, w: 88, h: 190, label: '', maxW: 8, maxH: 14 }
    ] ,
    back: [
      { code: 'BLLEG', x: 92, y: 255, w: 88, h: 190, label: '', maxW: 8, maxH: 14 },

      { code: 'BRLEG', x: 238, y: 255, w: 88, h: 190, label: '', maxW: 8, maxH: 14 }
    ]
    }
   },

  'sportswear': {
    dtg: { front: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    dtf: { front: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Chest', maxW: 16, maxH: 19 }
    ] ,
    back: [
      { x: 135, y: 170, w: 190, h: 280, label: 'Back', maxW: 16, maxH: 19 }
    ]
    },

    embroidery: {
      front: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ] ,
    back: [
      { x: 135, y: 125, w: 65, h: 65, label: 'Square', maxW: 3, maxH: 3 },

      { x: 135, y: 170, w: 160, h: 50, label: 'Horizontal', maxW: 3, maxH: 12 },

      { x: 135, y: 215, w: 160, h: 160, label: 'Large Square', maxW: 12, maxH: 12 }
    ]
    },

    sleeve: { leftSleeve: [
      { x: 200, y: 240, w: 100, h: 270, label: 'Left Sleeve', maxW: 6, maxH: 14 }
    ], rightSleeve: [
      { x: 100, y: 240, w: 100, h: 270, label: 'Right Sleeve', maxW: 6, maxH: 14 }
    ]
    }
  }
};
